/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

window.onload = function () {
   // インスタランダム表示
  const instaElms = document.querySelectorAll("#shopify-section-1533627605806 .flickity-slider > .Carousel__Cell")
  const elmLength = instaElms.length
  let nums = []
  for(let i = 2; i < elmLength; i++ ) { nums.push(i) }

  function shuffle(array) {
  var n = nums.length, t, i;

  while (n) {
    i = Math.floor(Math.random() * n--);
    t = array[n];
    array[n] = array[i];
    array[i] = t;
  }

  return array;
}

  	const shuffledNum = shuffle(nums)
  for(var i=1; i <= elmLength; i++ ) {
    instaElms[i - 1].style.order = i === 1 || i ===2 ? i + ''  : shuffledNum[i - 3] + ''
  }
}


// =====================
// === header-color-switch-fv ===
// =====================
const currentUrl = window.location.href.split('//')[1]
const host = location.host + '/'

if (currentUrl === host) {
  let header
let headerClassList
let headerH

let mainChildren
let elmHeight
  elmsHeightInit()

function elmsHeightInit() {
  header = document.getElementById("section-header")
  headerClassList = header.classList
  headerH = header.offsetHeight

  mainChildren = document.getElementById("main").children
  elmHeight = getH(mainChildren[0])

  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  scrollTop > elmHeight ? removeWhite() : addWhite()
}

window.onresize = function () {
 elmsHeightInit()
}

window.onscroll = function () {
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  if (scrollTop <= 10) {
    addWhite()
  } else if (scrollTop > 10 && scrollTop <= elmHeight) {
    addWhite()
  } else {
    removeWhite()
  }
}
function getH(elm) {
  const windowTop = elm.getBoundingClientRect().top + window.pageYOffset
  const turnPoint = windowTop + elm.offsetHeight - headerH / 2
  return Math.floor(turnPoint)
}

function addWhite() {
  headerClassList.add("header-white")
}

function removeWhite() {
  headerClassList.remove("header-white")
}
}



//動画表示JS
//以下を追加
//Cookie
document.addEventListener("DOMContentLoaded", () => {

  if ( sessionStorage.getItem("visited") ) {
  
    document.getElementById("mvplayer").remove();
  
  } else {
    
  const root = location.protocol + '//' + location.hostname
  const rootSl = root + '/'
  const curUrl = location.href
  
  if ( (curUrl !== root) && (curUrl !== rootSl) ) return false
  
  
    sessionStorage.setItem("visited", 1)
    
    $(".movie").css("display","block")
    var $main = $('#main')
    $main.hide()
    
    setTimeout(function(){
      $('#mvplayer').fadeOut();
      $main.show()
    },0)
    
  }
});


/**
 * ----------------------------------------------------------------------------
 * items accordion
 * ----------------------------------------------------------------------------
 */

var product__wrapper_margin_bottom = 0;

$('#accordion-wrap').children('.accordion').on('click', function () {
    const t = $(this)
    t.children('.details').slideToggle()
    t.toggleClass('opened')
    
   	if (window.matchMedia('screen and (min-width:1008px)').matches) { 
	//768px以上のデスクトップでの処理

		if(t.hasClass('opened'))
   			product__wrapper_margin_bottom += 260;
  		 else{
  	 	   	product__wrapper_margin_bottom -= 260;
  	 	 }
		var e = document.getElementsByClassName("Product__Wrapper");
     	e[0].style.marginBottom =  product__wrapper_margin_bottom + 'px';

    }
 	 
});


/**
 * ----------------------------------------------------------------------------
 * User's Voice next/prev button
 * ----------------------------------------------------------------------------
 */

function scrollPrev() {
    var leftPos = $('.TestimonialNav').scrollLeft();

    $(".TestimonialNav").animate({scrollLeft:leftPos - 170});

}

function scrollNext() {
    var leftPos = $('.TestimonialNav').scrollLeft();
    $(".TestimonialNav").animate({scrollLeft:leftPos + 170});
}

/*$(function () {
  var off = $('.TestimonialNav').offset();
});*/


/**
 * ----------------------------------------------------------------------------
 * faq
 * ----------------------------------------------------------------------------
 */

$('.FaqSummary__List ').on('click', function () { 
  var index = $('.FaqSummary__List').index(this)+1;
       $(".FaqSummary_test").fadeOut("normal");
       $(".seprator"+index).fadeIn("normal");
       
});

$('.returnTopStatus').on('click', function () { 

       $(".Faq_separator_clear").fadeOut("normal");
       $(".FaqSummary_test").fadeIn("normal");
       
});


/* 
  // li要素をループ処理
  $('.Faq__Item').each(function() {
    // コンソールに1つずつ出力
    if( /送/ == $(this).children(".Faq__Question").text())console.log(true);
 
  });
});*/


function createFaqDict() {
  let faqDict = []
  
  $('.Faq').children('.Faq_separator_clear').each( function(idx, elm) {
    let categoryRow = []
    
    $(elm).children('.Faq__Item').each( function(i, faqItem) {
      
      const help = $(faqItem)
      const que = help.find('.Faq__Question').text()
      const answer = help.find('.Faq__Answer').children('p')
      let answerTexts = ''
      
      $.each( answer, function(j, p)  { answerTexts + p.innerText })
      
      categoryRow.push( { [que]: answerTexts } )
    })
    
    faqDict.push(categoryRow)
    
  })
  
 return faqDict
  
}

function searchFaq(txt) {
  const faqDict = createFaqDict()
  $('.Faq__Item').hide()
  
  $.each( faqDict, function(i, cateRow) {
    
    $.each(cateRow, function(j, help) {
      
      for (let k in help) {
        
        const reg = new RegExp(txt + '(.*?)', 'i')
        
        if (k.match(reg) || help[k].match(reg)) {
          
          console.log('match!!!!!!!!!', i, j)
          
          const helpWrap = $('.Faq').children('.Faq_separator_clear.seprator' + ( i +1 ))
          const help = helpWrap.children('.Faq__Item')[j]
          
          helpWrap.fadeIn('fast')
          $(help).show()
          
        }
        
      }
      
    })
    
  })
  
}


// FAQ検索
$(function () {
  
  $( '#search_area' ).find('input').keypress( function ( e ) {
	if ( e.which == 13 ) {
      const val = e.target.value
      
      if(val === '') return false
      
      $('.Faq_separator_clear').hide()
      $('.FaqSummary_test').hide()
      
      searchFaq(val)
	}
  })
  
  // カテゴリクリック時
  $('.FaqSummary__List').on('click', function() {
    $('.Faq__Item').show()
  })
  
  // パンくずリストからfaqトップへ戻る時
  $('.returnTopStatus').on('click', function() {
    $('.Faq__Item').hide()
  })
})



// 今すぐ購入ボタン表示
$(function () {
  
  const curUrl = location.href
  const productPath = 'https://denis.jp/collections'

  const reg = new RegExp(productPath + '(.*?)', 'g')

  const isProductPage = curUrl.match(reg)
 
  
  const param = '?shopify-debug=true&show=checkout'
  
  if (isProductPage && location.search === '' ) history.replaceState('', '', param)
  
})

$(function () {
  
  const curUrl = location.href
  const seasonProductPath  = 'https://denis.jp/products'
  
  const reg = new RegExp(seasonProductPath + '(.*?)', 'g')

  const isProductPage = curUrl.match(reg)
 
  
  const param = '?shopify-debug=true&show=checkout'
  
  if (isProductPage && location.search === '' ) history.replaceState('', '', param)
  
})





$('.pc_wrapper li').click(function() {
  var index = $('.pc_wrapper li').index($(this));
  var current;
  if ($(".pc_wrapper .slide").scrollLeft() != 0)
    current = Math.round($(".pc_wrapper .slide").scrollLeft() / 299.4 + 0.4);
  else
    current = 0;
  //console.log(current);
  $('.pc_wrapper .slide img').eq(current).removeClass("is_selected");
  $('.pc_wrapper li').eq(current).removeClass("is-selected");  
  var pos = index * 299.4;
  $(".pc_wrapper .slide").animate({
    scrollLeft: pos
  });
  $('.pc_wrapper .slide img').eq(index).addClass("is_selected");
  $('.pc_wrapper li').eq(index).addClass("is-selected");
});

var current = 0;
$('.sp_wrapper li').click(function() {
  var index = $('.sp_wrapper li').index($(this));
  if (!$('.sp_wrapper .slide img').eq(index).hasClass("is_selected")) {
    $('.sp_wrapper .slide img').eq(current).fadeOut(500, function() {
        $('.sp_wrapper .slide img').eq(index).fadeIn();
        console.log(current);
        $('.sp_wrapper .slide img').eq(current).removeClass("is_selected");
        $('.sp_wrapper .slide img').eq(index).addClass("is_selected");
        $('.sp_wrapper li').eq(current).removeClass("is-selected");
        $('.sp_wrapper li').eq(index).addClass("is-selected");
        current = index;
      }
    );
  }
});





/* how to */
// ! modernizr 3.3.1 (Custom Build) | MIT *
//  * https://modernizr.com/download/?-flexbox-flexboxlegacy-flexwrap-setclasses !
// !function(e,n,t){function r(e,n){return typeof e===n}function o(){var e,n,t,o,s,i,a;for(var l in x)if(x.hasOwnProperty(l)){if(e=[],n=x[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(o=r(n.fn,"function")?n.fn():n.fn,s=0;s<e.length;s++)i=e[s],a=i.split("."),1===a.length?Modernizr[a[0]]=o:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=o),g.push((o?"":"no-")+a.join("-"))}}function s(e){var n=w.className,t=Modernizr._config.classPrefix||"";if(_&&(n=n.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(r,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),_?w.className.baseVal=n:w.className=n)}function i(e,n){return!!~(""+e).indexOf(n)}function a(e){return e.replace(/([a-z])-([a-z])/g,function(e,n,t){return n+t.toUpperCase()}).replace(/^-/,"")}function l(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):_?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function f(e,n){return function(){return e.apply(n,arguments)}}function u(e,n,t){var o;for(var s in e)if(e[s]in n)return t===!1?e[s]:(o=n[e[s]],r(o,"function")?f(o,t||n):o);return!1}function d(e){return e.replace(/([A-Z])/g,function(e,n){return"-"+n.toLowerCase()}).replace(/^ms-/,"-ms-")}function p(){var e=n.body;return e||(e=l(_?"svg":"body"),e.fake=!0),e}function c(e,t,r,o){var s,i,a,f,u="modernizr",d=l("div"),c=p();if(parseInt(r,10))for(;r--;)a=l("div"),a.id=o?o[r]:u+(r+1),d.appendChild(a);return s=l("style"),s.type="text/css",s.id="s"+u,(c.fake?c:d).appendChild(s),c.appendChild(d),s.styleSheet?s.styleSheet.cssText=e:s.appendChild(n.createTextNode(e)),d.id=u,c.fake&&(c.style.background="",c.style.overflow="hidden",f=w.style.overflow,w.style.overflow="hidden",w.appendChild(c)),i=t(d,e),c.fake?(c.parentNode.removeChild(c),w.style.overflow=f,w.offsetHeight):d.parentNode.removeChild(d),!!i}function m(n,r){var o=n.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(d(n[o]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var s=[];o--;)s.push("("+d(n[o])+":"+r+")");return s=s.join(" or "),c("@supports ("+s+") { #modernizr { position: absolute; } }",function(e){return"absolute"==getComputedStyle(e,null).position})}return t}function h(e,n,o,s){function f(){d&&(delete T.style,delete T.modElem)}if(s=r(s,"undefined")?!1:s,!r(o,"undefined")){var u=m(e,o);if(!r(u,"undefined"))return u}for(var d,p,c,h,v,y=["modernizr","tspan","samp"];!T.style&&y.length;)d=!0,T.modElem=l(y.shift()),T.style=T.modElem.style;for(c=e.length,p=0;c>p;p++)if(h=e[p],v=T.style[h],i(h,"-")&&(h=a(h)),T.style[h]!==t){if(s||r(o,"undefined"))return f(),"pfx"==n?h:!0;try{T.style[h]=o}catch(g){}if(T.style[h]!=v)return f(),"pfx"==n?h:!0}return f(),!1}function v(e,n,t,o,s){var i=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+b.join(i+" ")+i).split(" ");return r(n,"string")||r(n,"undefined")?h(a,n,o,s):(a=(e+" "+E.join(i+" ")+i).split(" "),u(a,n,t))}function y(e,n,r){return v(e,t,t,n,r)}var g=[],x=[],C={_version:"3.3.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){x.push({name:e,fn:n,options:t})},addAsyncTest:function(e){x.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=C,Modernizr=new Modernizr;var w=n.documentElement,_="svg"===w.nodeName.toLowerCase(),S="Moz O ms Webkit",b=C._config.usePrefixes?S.split(" "):[];C._cssomPrefixes=b;var E=C._config.usePrefixes?S.toLowerCase().split(" "):[];C._domPrefixes=E;var P={elem:l("modernizr")};Modernizr._q.push(function(){delete P.elem});var T={style:P.elem.style};Modernizr._q.unshift(function(){delete T.style}),C.testAllProps=v,C.testAllProps=y,Modernizr.addTest("flexwrap",y("flexWrap","wrap",!0)),Modernizr.addTest("flexbox",y("flexBasis","1px",!0)),Modernizr.addTest("flexboxlegacy",y("boxDirection","reverse",!0)),o(),s(g),delete C.addTest,delete C.addAsyncTest;for(var z=0;z<Modernizr._q.length;z++)Modernizr._q[z]();e.Modernizr=Modernizr}(window,document);

// jQuery.easing.jswing = jQuery.easing.swing, jQuery.extend(jQuery.easing, {
// 		def: "easeOutQuad",
// 		swing: function (a, b, c, d, e) {
// 			return jQuery.easing[jQuery.easing.def](a, b, c, d, e)
// 		},
// 		easeInQuad: function (a, b, c, d, e) {
// 			return d * (b /= e) * b + c
// 		},
// 		easeOutQuad: function (a, b, c, d, e) {
// 			return -d * (b /= e) * (b - 2) + c
// 		},
// 		easeInOutQuad: function (a, b, c, d, e) {
// 			return (b /= e / 2) < 1 ? d / 2 * b * b + c : -d / 2 * (--b * (b - 2) - 1) + c
// 		},
// 		easeInCubic: function (a, b, c, d, e) {
// 			return d * (b /= e) * b * b + c
// 		},
// 		easeOutCubic: function (a, b, c, d, e) {
// 			return d * ((b = b / e - 1) * b * b + 1) + c
// 		},
// 		easeInOutCubic: function (a, b, c, d, e) {
// 			return (b /= e / 2) < 1 ? d / 2 * b * b * b + c : d / 2 * ((b -= 2) * b * b + 2) + c
// 		},
// 		easeInQuart: function (a, b, c, d, e) {
// 			return d * (b /= e) * b * b * b + c
// 		},
// 		easeOutQuart: function (a, b, c, d, e) {
// 			return -d * ((b = b / e - 1) * b * b * b - 1) + c
// 		},
// 		easeInOutQuart: function (a, b, c, d, e) {
// 			return (b /= e / 2) < 1 ? d / 2 * b * b * b * b + c : -d / 2 * ((b -= 2) * b * b * b - 2) + c
// 		},
// 		easeInQuint: function (a, b, c, d, e) {
// 			return d * (b /= e) * b * b * b * b + c
// 		},
// 		easeOutQuint: function (a, b, c, d, e) {
// 			return d * ((b = b / e - 1) * b * b * b * b + 1) + c
// 		},
// 		easeInOutQuint: function (a, b, c, d, e) {
// 			return (b /= e / 2) < 1 ? d / 2 * b * b * b * b * b + c : d / 2 * ((b -= 2) * b * b * b * b + 2) + c
// 		},
// 		easeInSine: function (a, b, c, d, e) {
// 			return -d * Math.cos(b / e * (Math.PI / 2)) + d + c
// 		},
// 		easeOutSine: function (a, b, c, d, e) {
// 			return d * Math.sin(b / e * (Math.PI / 2)) + c
// 		},
// 		easeInOutSine: function (a, b, c, d, e) {
// 			return -d / 2 * (Math.cos(Math.PI * b / e) - 1) + c
// 		},
// 		easeInExpo: function (a, b, c, d, e) {
// 			return 0 == b ? c : d * Math.pow(2, 10 * (b / e - 1)) + c
// 		},
// 		easeOutExpo: function (a, b, c, d, e) {
// 			return b == e ? c + d : d * (-Math.pow(2, -10 * b / e) + 1) + c
// 		},
// 		easeInOutExpo: function (a, b, c, d, e) {
// 			return 0 == b ? c : b == e ? c + d : (b /= e / 2) < 1 ? d / 2 * Math.pow(2, 10 * (b - 1)) + c : d / 2 * (-Math.pow(2, -10 * --b) + 2) + c
// 		},
// 		easeInCirc: function (a, b, c, d, e) {
// 			return -d * (Math.sqrt(1 - (b /= e) * b) - 1) + c
// 		},
// 		easeOutCirc: function (a, b, c, d, e) {
// 			return d * Math.sqrt(1 - (b = b / e - 1) * b) + c
// 		},
// 		easeInOutCirc: function (a, b, c, d, e) {
// 			return (b /= e / 2) < 1 ? -d / 2 * (Math.sqrt(1 - b * b) - 1) + c : d / 2 * (Math.sqrt(1 - (b -= 2) * b) + 1) + c
// 		},
// 		easeInElastic: function (a, b, c, d, e) {
// 			var f = 1.70158,
// 				g = 0,
// 				h = d;
// 			if (0 == b) return c;
// 			if (1 == (b /= e)) return c + d;
// 			if (g || (g = .3 * e), h < Math.abs(d)) {
// 				h = d;
// 				var f = g / 4
// 			} else var f = g / (2 * Math.PI) * Math.asin(d / h);
// 			return -(h * Math.pow(2, 10 * (b -= 1)) * Math.sin((b * e - f) * (2 * Math.PI) / g)) + c
// 		},
// 		easeOutElastic: function (a, b, c, d, e) {
// 			var f = 1.70158,
// 				g = 0,
// 				h = d;
// 			if (0 == b) return c;
// 			if (1 == (b /= e)) return c + d;
// 			if (g || (g = .3 * e), h < Math.abs(d)) {
// 				h = d;
// 				var f = g / 4
// 			} else var f = g / (2 * Math.PI) * Math.asin(d / h);
// 			return h * Math.pow(2, -10 * b) * Math.sin((b * e - f) * (2 * Math.PI) / g) + d + c
// 		},
// 		easeInOutElastic: function (a, b, c, d, e) {
// 			var f = 1.70158,
// 				g = 0,
// 				h = d;
// 			if (0 == b) return c;
// 			if (2 == (b /= e / 2)) return c + d;
// 			if (g || (g = e * (.3 * 1.5)), h < Math.abs(d)) {
// 				h = d;
// 				var f = g / 4
// 			} else var f = g / (2 * Math.PI) * Math.asin(d / h);
// 			return 1 > b ? -.5 * (h * Math.pow(2, 10 * (b -= 1)) * Math.sin((b * e - f) * (2 * Math.PI) / g)) + c : h * Math.pow(2, -10 * (b -= 1)) * Math.sin((b * e - f) * (2 * Math.PI) / g) * .5 + d + c
// 		},
// 		easeInBack: function (a, b, c, d, e, f) {
// 			return void 0 == f && (f = 1.70158), d * (b /= e) * b * ((f + 1) * b - f) + c
// 		},
// 		easeOutBack: function (a, b, c, d, e, f) {
// 			return void 0 == f && (f = 1.70158), d * ((b = b / e - 1) * b * ((f + 1) * b + f) + 1) + c
// 		},
// 		easeInOutBack: function (a, b, c, d, e, f) {
// 			return void 0 == f && (f = 1.70158), (b /= e / 2) < 1 ? d / 2 * (b * b * (((f *= 1.525) + 1) * b - f)) + c : d / 2 * ((b -= 2) * b * (((f *= 1.525) + 1) * b + f) + 2) + c
// 		},
// 		easeInBounce: function (a, b, c, d, e) {
// 			return d - jQuery.easing.easeOutBounce(a, e - b, 0, d, e) + c
// 		},
// 		easeOutBounce: function (a, b, c, d, e) {
// 			return (b /= e) < 1 / 2.75 ? d * (7.5625 * b * b) + c : 2 / 2.75 > b ? d * (7.5625 * (b -= 1.5 / 2.75) * b + .75) + c : 2.5 / 2.75 > b ? d * (7.5625 * (b -= 2.25 / 2.75) * b + .9375) + c : d * (7.5625 * (b -= 2.625 / 2.75) * b + .984375) + c
// 		},
// 		easeInOutBounce: function (a, b, c, d, e) {
// 			return e / 2 > b ? .5 * jQuery.easing.easeInBounce(a, 2 * b, 0, d, e) + c : .5 * jQuery.easing.easeOutBounce(a, 2 * b - e, 0, d, e) + .5 * d + c
// 		}
// 	}),
// 	function (a) {
// 		"function" == typeof define && define.amd ? define(["jquery"], a) : "object" == typeof exports ? module.exports = a : a(jQuery)
// 	}(function (a) {
// 		function b(b) {
// 			var g = b || window.event,
// 				h = i.call(arguments, 1),
// 				j = 0,
// 				l = 0,
// 				m = 0,
// 				n = 0,
// 				o = 0,
// 				p = 0;
// 			if (b = a.event.fix(g), b.type = "mousewheel", "detail" in g && (m = -1 * g.detail), "wheelDelta" in g && (m = g.wheelDelta), "wheelDeltaY" in g && (m = g.wheelDeltaY), "wheelDeltaX" in g && (l = -1 * g.wheelDeltaX), "axis" in g && g.axis === g.HORIZONTAL_AXIS && (l = -1 * m, m = 0), j = 0 === m ? l : m, "deltaY" in g && (m = -1 * g.deltaY, j = m), "deltaX" in g && (l = g.deltaX, 0 === m && (j = -1 * l)), 0 !== m || 0 !== l) {
// 				if (1 === g.deltaMode) {
// 					var q = a.data(this, "mousewheel-line-height");
// 					j *= q, m *= q, l *= q
// 				} else if (2 === g.deltaMode) {
// 					var r = a.data(this, "mousewheel-page-height");
// 					j *= r, m *= r, l *= r
// 				}
// 				if (n = Math.max(Math.abs(m), Math.abs(l)), (!f || f > n) && (f = n, d(g, n) && (f /= 40)), d(g, n) && (j /= 40, l /= 40, m /= 40), j = Math[j >= 1 ? "floor" : "ceil"](j / f), l = Math[l >= 1 ? "floor" : "ceil"](l / f), m = Math[m >= 1 ? "floor" : "ceil"](m / f), k.settings.normalizeOffset && this.getBoundingClientRect) {
// 					var s = this.getBoundingClientRect();
// 					o = b.clientX - s.left, p = b.clientY - s.top
// 				}
// 				return b.deltaX = l, b.deltaY = m, b.deltaFactor = f, b.offsetX = o, b.offsetY = p, b.deltaMode = 0, h.unshift(b, j, l, m), e && clearTimeout(e), e = setTimeout(c, 200), (a.event.dispatch || a.event.handle).apply(this, h)
// 			}
// 		}

// 		function c() {
// 			f = null
// 		}

// 		function d(a, b) {
// 			return k.settings.adjustOldDeltas && "mousewheel" === a.type && b % 120 === 0
// 		}
// 		var e, f, g = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
// 			h = "onwheel" in document || document.documentMode >= 9 ? ["wheel"] : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
// 			i = Array.prototype.slice;
// 		if (a.event.fixHooks)
// 			for (var j = g.length; j;) a.event.fixHooks[g[--j]] = a.event.mouseHooks;
// 		var k = a.event.special.mousewheel = {
// 			version: "3.1.12",
// 			setup: function () {
// 				if (this.addEventListener)
// 					for (var c = h.length; c;) this.addEventListener(h[--c], b, !1);
// 				else this.onmousewheel = b;
// 				a.data(this, "mousewheel-line-height", k.getLineHeight(this)), a.data(this, "mousewheel-page-height", k.getPageHeight(this))
// 			},
// 			teardown: function () {
// 				if (this.removeEventListener)
// 					for (var c = h.length; c;) this.removeEventListener(h[--c], b, !1);
// 				else this.onmousewheel = null;
// 				a.removeData(this, "mousewheel-line-height"), a.removeData(this, "mousewheel-page-height")
// 			},
// 			getLineHeight: function (b) {
// 				var c = a(b),
// 					d = c["offsetParent" in a.fn ? "offsetParent" : "parent"]();
// 				return d.length || (d = a("body")), parseInt(d.css("fontSize"), 10) || parseInt(c.css("fontSize"), 10) || 16
// 			},
// 			getPageHeight: function (b) {
// 				return a(b).height()
// 			},
// 			settings: {
// 				adjustOldDeltas: !0,
// 				normalizeOffset: !0
// 			}
// 		};
// 		a.fn.extend({
// 			mousewheel: function (a) {
// 				return a ? this.bind("mousewheel", a) : this.trigger("mousewheel")
// 			},
// 			unmousewheel: function (a) {
// 				return this.unbind("mousewheel", a)
// 			}
// 		})
// 	}),
// 	function (a) {
// 		var b, c, d = a.event;
// 		b = d.special.debouncedresize = {
// 			setup: function () {
// 				a(this).on("resize", b.handler)
// 			},
// 			teardown: function () {
// 				a(this).off("resize", b.handler)
// 			},
// 			handler: function (a, e) {
// 				var f = this,
// 					g = arguments,
// 					h = function () {
// 						a.type = "debouncedresize", d.dispatch.apply(f, g)
// 					};
// 				c && clearTimeout(c), e ? h() : c = setTimeout(h, b.threshold)
// 			},
// 			threshold: 350
// 		}
// 	}(jQuery),
// 	function (a) {
// 		function b() {}

// 		function c(a) {
// 			function c(b) {
// 				b.prototype.option || (b.prototype.option = function (b) {
// 					a.isPlainObject(b) && (this.options = a.extend(!0, this.options, b))
// 				})
// 			}

// 			function e(b, c) {
// 				a.fn[b] = function (e) {
// 					if ("string" == typeof e) {
// 						for (var g = d.call(arguments, 1), h = 0, i = this.length; i > h; h++) {
// 							var j = this[h],
// 								k = a.data(j, b);
// 							if (k)
// 								if (a.isFunction(k[e]) && "_" !== e.charAt(0)) {
// 									var l = k[e].apply(k, g);
// 									if (void 0 !== l) return l
// 								} else f("no such method '" + e + "' for " + b + " instance");
// 							else f("cannot call methods on " + b + " prior to initialization; attempted to call '" + e + "'")
// 						}
// 						return this
// 					}
// 					return this.each(function () {
// 						var d = a.data(this, b);
// 						d ? (d.option(e), d._init()) : (d = new c(this, e), a.data(this, b, d))
// 					})
// 				}
// 			}
// 			if (a) {
// 				var f = "undefined" == typeof console ? b : function (a) {
// 					console.error(a)
// 				};
// 				return a.bridget = function (a, b) {
// 					c(b), e(a, b)
// 				}, a.bridget
// 			}
// 		}
// 		var d = Array.prototype.slice;
// 		"function" == typeof define && define.amd ? define("jquery-bridget/jquery.bridget", ["jquery"], c) : c("object" == typeof exports ? require("jquery") : a.jQuery)
// 	}(window),
// 	function (a) {
// 		function b(a) {
// 			return new RegExp("(^|\\s+)" + a + "(\\s+|$)")
// 		}

// 		function c(a, b) {
// 			var c = d(a, b) ? f : e;
// 			c(a, b)
// 		}
// 		var d, e, f;
// 		"classList" in document.documentElement ? (d = function (a, b) {
// 			return a.classList.contains(b)
// 		}, e = function (a, b) {
// 			a.classList.add(b)
// 		}, f = function (a, b) {
// 			a.classList.remove(b)
// 		}) : (d = function (a, c) {
// 			return b(c).test(a.className)
// 		}, e = function (a, b) {
// 			d(a, b) || (a.className = a.className + " " + b)
// 		}, f = function (a, c) {
// 			a.className = a.className.replace(b(c), " ")
// 		});
// 		var g = {
// 			hasClass: d,
// 			addClass: e,
// 			removeClass: f,
// 			toggleClass: c,
// 			has: d,
// 			add: e,
// 			remove: f,
// 			toggle: c
// 		};
// 		"function" == typeof define && define.amd ? define("classie/classie", g) : "object" == typeof exports ? module.exports = g : a.classie = g
// 	}(window),
// 	function () {
// 		"use strict";

// 		function a() {}

// 		function b(a, b) {
// 			for (var c = a.length; c--;)
// 				if (a[c].listener === b) return c;
// 			return -1
// 		}

// 		function c(a) {
// 			return function () {
// 				return this[a].apply(this, arguments)
// 			}
// 		}
// 		var d = a.prototype,
// 			e = this,
// 			f = e.EventEmitter;
// 		d.getListeners = function (a) {
// 			var b, c, d = this._getEvents();
// 			if (a instanceof RegExp) {
// 				b = {};
// 				for (c in d) d.hasOwnProperty(c) && a.test(c) && (b[c] = d[c])
// 			} else b = d[a] || (d[a] = []);
// 			return b
// 		}, d.flattenListeners = function (a) {
// 			var b, c = [];
// 			for (b = 0; b < a.length; b += 1) c.push(a[b].listener);
// 			return c
// 		}, d.getListenersAsObject = function (a) {
// 			var b, c = this.getListeners(a);
// 			return c instanceof Array && (b = {}, b[a] = c), b || c
// 		}, d.addListener = function (a, c) {
// 			var d, e = this.getListenersAsObject(a),
// 				f = "object" == typeof c;
// 			for (d in e) e.hasOwnProperty(d) && -1 === b(e[d], c) && e[d].push(f ? c : {
// 				listener: c,
// 				once: !1
// 			});
// 			return this
// 		}, d.on = c("addListener"), d.addOnceListener = function (a, b) {
// 			return this.addListener(a, {
// 				listener: b,
// 				once: !0
// 			})
// 		}, d.once = c("addOnceListener"), d.defineEvent = function (a) {
// 			return this.getListeners(a), this
// 		}, d.defineEvents = function (a) {
// 			for (var b = 0; b < a.length; b += 1) this.defineEvent(a[b]);
// 			return this
// 		}, d.removeListener = function (a, c) {
// 			var d, e, f = this.getListenersAsObject(a);
// 			for (e in f) f.hasOwnProperty(e) && (d = b(f[e], c), -1 !== d && f[e].splice(d, 1));
// 			return this
// 		}, d.off = c("removeListener"), d.addListeners = function (a, b) {
// 			return this.manipulateListeners(!1, a, b)
// 		}, d.removeListeners = function (a, b) {
// 			return this.manipulateListeners(!0, a, b)
// 		}, d.manipulateListeners = function (a, b, c) {
// 			var d, e, f = a ? this.removeListener : this.addListener,
// 				g = a ? this.removeListeners : this.addListeners;
// 			if ("object" != typeof b || b instanceof RegExp)
// 				for (d = c.length; d--;) f.call(this, b, c[d]);
// 			else
// 				for (d in b) b.hasOwnProperty(d) && (e = b[d]) && ("function" == typeof e ? f.call(this, d, e) : g.call(this, d, e));
// 			return this
// 		}, d.removeEvent = function (a) {
// 			var b, c = typeof a,
// 				d = this._getEvents();
// 			if ("string" === c) delete d[a];
// 			else if (a instanceof RegExp)
// 				for (b in d) d.hasOwnProperty(b) && a.test(b) && delete d[b];
// 			else delete this._events;
// 			return this
// 		}, d.removeAllListeners = c("removeEvent"), d.emitEvent = function (a, b) {
// 			var c, d, e, f, g = this.getListenersAsObject(a);
// 			for (e in g)
// 				if (g.hasOwnProperty(e))
// 					for (d = g[e].length; d--;) c = g[e][d], c.once === !0 && this.removeListener(a, c.listener), f = c.listener.apply(this, b || []), f === this._getOnceReturnValue() && this.removeListener(a, c.listener);
// 			return this
// 		}, d.trigger = c("emitEvent"), d.emit = function (a) {
// 			var b = Array.prototype.slice.call(arguments, 1);
// 			return this.emitEvent(a, b)
// 		}, d.setOnceReturnValue = function (a) {
// 			return this._onceReturnValue = a, this
// 		}, d._getOnceReturnValue = function () {
// 			return this.hasOwnProperty("_onceReturnValue") ? this._onceReturnValue : !0
// 		}, d._getEvents = function () {
// 			return this._events || (this._events = {})
// 		}, a.noConflict = function () {
// 			return e.EventEmitter = f, a
// 		}, "function" == typeof define && define.amd ? define("eventEmitter/EventEmitter", [], function () {
// 			return a
// 		}) : "object" == typeof module && module.exports ? module.exports = a : e.EventEmitter = a
// 	}.call(this),
// 	function (a) {
// 		function b(b) {
// 			var c = a.event;
// 			return c.target = c.target || c.srcElement || b, c
// 		}
// 		var c = document.documentElement,
// 			d = function () {};
// 		c.addEventListener ? d = function (a, b, c) {
// 			a.addEventListener(b, c, !1)
// 		} : c.attachEvent && (d = function (a, c, d) {
// 			a[c + d] = d.handleEvent ? function () {
// 				var c = b(a);
// 				d.handleEvent.call(d, c)
// 			} : function () {
// 				var c = b(a);
// 				d.call(a, c)
// 			}, a.attachEvent("on" + c, a[c + d])
// 		});
// 		var e = function () {};
// 		c.removeEventListener ? e = function (a, b, c) {
// 			a.removeEventListener(b, c, !1)
// 		} : c.detachEvent && (e = function (a, b, c) {
// 			a.detachEvent("on" + b, a[b + c]);
// 			try {
// 				delete a[b + c]
// 			} catch (d) {
// 				a[b + c] = void 0
// 			}
// 		});
// 		var f = {
// 			bind: d,
// 			unbind: e
// 		};
// 		"function" == typeof define && define.amd ? define("eventie/eventie", f) : "object" == typeof exports ? module.exports = f : a.eventie = f
// 	}(window),
// 	function (a) {
// 		function b(a) {
// 			if (a) {
// 				if ("string" == typeof d[a]) return a;
// 				a = a.charAt(0).toUpperCase() + a.slice(1);
// 				for (var b, e = 0, f = c.length; f > e; e++)
// 					if (b = c[e] + a, "string" == typeof d[b]) return b
// 			}
// 		}
// 		var c = "Webkit Moz ms Ms O".split(" "),
// 			d = document.documentElement.style;
// 		"function" == typeof define && define.amd ? define("get-style-property/get-style-property", [], function () {
// 			return b
// 		}) : "object" == typeof exports ? module.exports = b : a.getStyleProperty = b
// 	}(window),
// 	function (a, b) {
// 		function c(a) {
// 			var b = parseFloat(a),
// 				c = -1 === a.indexOf("%") && !isNaN(b);
// 			return c && b
// 		}

// 		function d() {}

// 		function e() {
// 			for (var a = {
// 					width: 0,
// 					height: 0,
// 					innerWidth: 0,
// 					innerHeight: 0,
// 					outerWidth: 0,
// 					outerHeight: 0
// 				}, b = 0, c = h.length; c > b; b++) {
// 				var d = h[b];
// 				a[d] = 0
// 			}
// 			return a
// 		}

// 		function f(b) {
// 			function d() {
// 				if (!m) {
// 					m = !0;
// 					var d = a.getComputedStyle;
// 					if (j = function () {
// 							var a = d ? function (a) {
// 								return d(a, null)
// 							} : function (a) {
// 								return a.currentStyle
// 							};
// 							return function (b) {
// 								var c = a(b);
// 								return c || g("Style returned " + c + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"), c
// 							}
// 						}(), k = b("boxSizing")) {
// 						var e = document.createElement("div");
// 						e.style.width = "200px", e.style.padding = "1px 2px 3px 4px", e.style.borderStyle = "solid", e.style.borderWidth = "1px 2px 3px 4px", e.style[k] = "border-box";
// 						var f = document.body || document.documentElement;
// 						f.appendChild(e);
// 						var h = j(e);
// 						l = 200 === c(h.width), f.removeChild(e)
// 					}
// 				}
// 			}

// 			function f(a) {
// 				if (d(), "string" == typeof a && (a = document.querySelector(a)), a && "object" == typeof a && a.nodeType) {
// 					var b = j(a);
// 					if ("none" === b.display) return e();
// 					var f = {};
// 					f.width = a.offsetWidth, f.height = a.offsetHeight;
// 					for (var g = f.isBorderBox = !(!k || !b[k] || "border-box" !== b[k]), m = 0, n = h.length; n > m; m++) {
// 						var o = h[m],
// 							p = b[o];
// 						p = i(a, p);
// 						var q = parseFloat(p);
// 						f[o] = isNaN(q) ? 0 : q
// 					}
// 					var r = f.paddingLeft + f.paddingRight,
// 						s = f.paddingTop + f.paddingBottom,
// 						t = f.marginLeft + f.marginRight,
// 						u = f.marginTop + f.marginBottom,
// 						v = f.borderLeftWidth + f.borderRightWidth,
// 						w = f.borderTopWidth + f.borderBottomWidth,
// 						x = g && l,
// 						y = c(b.width);
// 					y !== !1 && (f.width = y + (x ? 0 : r + v));
// 					var z = c(b.height);
// 					return z !== !1 && (f.height = z + (x ? 0 : s + w)), f.innerWidth = f.width - (r + v), f.innerHeight = f.height - (s + w), f.outerWidth = f.width + t, f.outerHeight = f.height + u, f
// 				}
// 			}

// 			function i(b, c) {
// 				if (a.getComputedStyle || -1 === c.indexOf("%")) return c;
// 				var d = b.style,
// 					e = d.left,
// 					f = b.runtimeStyle,
// 					g = f && f.left;
// 				return g && (f.left = b.currentStyle.left), d.left = c, c = d.pixelLeft, d.left = e, g && (f.left = g), c
// 			}
// 			var j, k, l, m = !1;
// 			return f
// 		}
// 		var g = "undefined" == typeof console ? d : function (a) {
// 				console.error(a)
// 			},
// 			h = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"];
// 		"function" == typeof define && define.amd ? define("get-size/get-size", ["get-style-property/get-style-property"], f) : "object" == typeof exports ? module.exports = f(require("desandro-get-style-property")) : a.getSize = f(a.getStyleProperty)
// 	}(window),
// 	function (a) {
// 		function b(a) {
// 			"function" == typeof a && (b.isReady ? a() : g.push(a))
// 		}

// 		function c(a) {
// 			var c = "readystatechange" === a.type && "complete" !== f.readyState;
// 			b.isReady || c || d()
// 		}

// 		function d() {
// 			b.isReady = !0;
// 			for (var a = 0, c = g.length; c > a; a++) {
// 				var d = g[a];
// 				d()
// 			}
// 		}

// 		function e(e) {
// 			return "complete" === f.readyState ? d() : (e.bind(f, "DOMContentLoaded", c), e.bind(f, "readystatechange", c), e.bind(a, "load", c)), b
// 		}
// 		var f = a.document,
// 			g = [];
// 		b.isReady = !1, "function" == typeof define && define.amd ? define("doc-ready/doc-ready", ["eventie/eventie"], e) : "object" == typeof exports ? module.exports = e(require("eventie")) : a.docReady = e(a.eventie)
// 	}(window),
// 	function (a) {
// 		"use strict";

// 		function b(a, b) {
// 			return a[g](b)
// 		}

// 		function c(a) {
// 			if (!a.parentNode) {
// 				var b = document.createDocumentFragment();
// 				b.appendChild(a)
// 			}
// 		}

// 		function d(a, b) {
// 			c(a);
// 			for (var d = a.parentNode.querySelectorAll(b), e = 0, f = d.length; f > e; e++)
// 				if (d[e] === a) return !0;
// 			return !1
// 		}

// 		function e(a, d) {
// 			return c(a), b(a, d)
// 		}
// 		var f, g = function () {
// 			if (a.matches) return "matches";
// 			if (a.matchesSelector) return "matchesSelector";
// 			for (var b = ["webkit", "moz", "ms", "o"], c = 0, d = b.length; d > c; c++) {
// 				var e = b[c],
// 					f = e + "MatchesSelector";
// 				if (a[f]) return f
// 			}
// 		}();
// 		if (g) {
// 			var h = document.createElement("div"),
// 				i = b(h, "div");
// 			f = i ? b : e
// 		} else f = d;
// 		"function" == typeof define && define.amd ? define("matches-selector/matches-selector", [], function () {
// 			return f
// 		}) : "object" == typeof exports ? module.exports = f : window.matchesSelector = f
// 	}(Element.prototype),
// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["doc-ready/doc-ready", "matches-selector/matches-selector"], function (c, d) {
// 			return b(a, c, d)
// 		}) : "object" == typeof exports ? module.exports = b(a, require("doc-ready"), require("desandro-matches-selector")) : a.fizzyUIUtils = b(a, a.docReady, a.matchesSelector)
// 	}(window, function (a, b, c) {
// 		var d = {};
// 		d.extend = function (a, b) {
// 			for (var c in b) a[c] = b[c];
// 			return a
// 		}, d.modulo = function (a, b) {
// 			return (a % b + b) % b
// 		};
// 		var e = Object.prototype.toString;
// 		d.isArray = function (a) {
// 			return "[object Array]" == e.call(a)
// 		}, d.makeArray = function (a) {
// 			var b = [];
// 			if (d.isArray(a)) b = a;
// 			else if (a && "number" == typeof a.length)
// 				for (var c = 0, e = a.length; e > c; c++) b.push(a[c]);
// 			else b.push(a);
// 			return b
// 		}, d.indexOf = Array.prototype.indexOf ? function (a, b) {
// 			return a.indexOf(b)
// 		} : function (a, b) {
// 			for (var c = 0, d = a.length; d > c; c++)
// 				if (a[c] === b) return c;
// 			return -1
// 		}, d.removeFrom = function (a, b) {
// 			var c = d.indexOf(a, b); - 1 != c && a.splice(c, 1)
// 		}, d.isElement = "function" == typeof HTMLElement || "object" == typeof HTMLElement ? function (a) {
// 			return a instanceof HTMLElement
// 		} : function (a) {
// 			return a && "object" == typeof a && 1 == a.nodeType && "string" == typeof a.nodeName
// 		}, d.setText = function () {
// 			function a(a, c) {
// 				b = b || (void 0 !== document.documentElement.textContent ? "textContent" : "innerText"), a[b] = c
// 			}
// 			var b;
// 			return a
// 		}(), d.getParent = function (a, b) {
// 			for (; a != document.body;)
// 				if (a = a.parentNode, c(a, b)) return a
// 		}, d.getQueryElement = function (a) {
// 			return "string" == typeof a ? document.querySelector(a) : a
// 		}, d.handleEvent = function (a) {
// 			var b = "on" + a.type;
// 			this[b] && this[b](a)
// 		}, d.filterFindElements = function (a, b) {
// 			a = d.makeArray(a);
// 			for (var e = [], f = 0, g = a.length; g > f; f++) {
// 				var h = a[f];
// 				if (d.isElement(h))
// 					if (b) {
// 						c(h, b) && e.push(h);
// 						for (var i = h.querySelectorAll(b), j = 0, k = i.length; k > j; j++) e.push(i[j])
// 					} else e.push(h)
// 			}
// 			return e
// 		}, d.debounceMethod = function (a, b, c) {
// 			var d = a.prototype[b],
// 				e = b + "Timeout";
// 			a.prototype[b] = function () {
// 				var a = this[e];
// 				a && clearTimeout(a);
// 				var b = arguments,
// 					f = this;
// 				this[e] = setTimeout(function () {
// 					d.apply(f, b), delete f[e]
// 				}, c || 100)
// 			}
// 		}, d.toDashed = function (a) {
// 			return a.replace(/(.)([A-Z])/g, function (a, b, c) {
// 				return b + "-" + c
// 			}).toLowerCase()
// 		};
// 		var f = a.console;
// 		return d.htmlInit = function (c, e) {
// 			b(function () {
// 				for (var b = d.toDashed(e), g = document.querySelectorAll(".js-" + b), h = "data-" + b + "-options", i = 0, j = g.length; j > i; i++) {
// 					var k, l = g[i],
// 						m = l.getAttribute(h);
// 					try {
// 						k = m && JSON.parse(m)
// 					} catch (n) {
// 						f && f.error("Error parsing " + h + " on " + l.nodeName.toLowerCase() + (l.id ? "#" + l.id : "") + ": " + n);
// 						continue
// 					}
// 					var o = new c(l, k),
// 						p = a.jQuery;
// 					p && p.data(l, e, o)
// 				}
// 			})
// 		}, d
// 	}),
// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define("flickity/js/cell", ["get-size/get-size"], function (c) {
// 			return b(a, c)
// 		}) : "object" == typeof exports ? module.exports = b(a, require("get-size")) : (a.Flickity = a.Flickity || {}, a.Flickity.Cell = b(a, a.getSize))
// 	}(window, function (a, b) {
// 		function c(a, b) {
// 			this.element = a, this.parent = b, this.create()
// 		}
// 		var d = "attachEvent" in a;
// 		return c.prototype.create = function () {
// 			this.element.style.position = "absolute", d && this.element.setAttribute("unselectable", "on"), this.x = 0, this.shift = 0
// 		}, c.prototype.destroy = function () {
// 			this.element.style.position = "";
// 			var a = this.parent.originSide;
// 			this.element.style[a] = ""
// 		}, c.prototype.getSize = function () {
// 			this.size = b(this.element)
// 		}, c.prototype.setPosition = function (a) {
// 			this.x = a, this.setDefaultTarget(), this.renderPosition(a)
// 		}, c.prototype.setDefaultTarget = function () {
// 			var a = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
// 			this.target = this.x + this.size[a] + this.size.width * this.parent.cellAlign
// 		}, c.prototype.renderPosition = function (a) {
// 			var b = this.parent.originSide;
// 			this.element.style[b] = this.parent.getPositionValue(a)
// 		}, c.prototype.wrapShift = function (a) {
// 			this.shift = a, this.renderPosition(this.x + this.parent.slideableWidth * a)
// 		}, c.prototype.remove = function () {
// 			this.element.parentNode.removeChild(this.element)
// 		}, c
// 	}),
// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define("flickity/js/animate", ["get-style-property/get-style-property", "fizzy-ui-utils/utils"], function (c, d) {
// 			return b(a, c, d)
// 		}) : "object" == typeof exports ? module.exports = b(a, require("desandro-get-style-property"), require("fizzy-ui-utils")) : (a.Flickity = a.Flickity || {}, a.Flickity.animatePrototype = b(a, a.getStyleProperty, a.fizzyUIUtils))
// 	}(window, function (a, b, c) {
// 		for (var d, e = 0, f = "webkit moz ms o".split(" "), g = a.requestAnimationFrame, h = a.cancelAnimationFrame, i = 0; i < f.length && (!g || !h); i++) d = f[i], g = g || a[d + "RequestAnimationFrame"], h = h || a[d + "CancelAnimationFrame"] || a[d + "CancelRequestAnimationFrame"];
// 		g && h || (g = function (b) {
// 			var c = (new Date).getTime(),
// 				d = Math.max(0, 16 - (c - e)),
// 				f = a.setTimeout(function () {
// 					b(c + d)
// 				}, d);
// 			return e = c + d, f
// 		}, h = function (b) {
// 			a.clearTimeout(b)
// 		});
// 		var j = {};
// 		j.startAnimation = function () {
// 			this.isAnimating || (this.isAnimating = !0, this.restingFrames = 0, this.animate())
// 		}, j.animate = function () {
// 			this.applyDragForce(), this.applySelectedAttraction();
// 			var a = this.x;
// 			if (this.integratePhysics(), this.positionSlider(), this.settle(a), this.isAnimating) {
// 				var b = this;
// 				g(function () {
// 					b.animate()
// 				})
// 			}
// 		};
// 		var k = b("transform"),
// 			l = !!b("perspective");
// 		return j.positionSlider = function () {
// 			var a = this.x;
// 			this.options.wrapAround && this.cells.length > 1 && (a = c.modulo(a, this.slideableWidth), a -= this.slideableWidth, this.shiftWrapCells(a)), a += this.cursorPosition, a = this.options.rightToLeft && k ? -a : a;
// 			var b = this.getPositionValue(a);
// 			k ? this.slider.style[k] = l && this.isAnimating ? "translate3d(" + b + ",0,0)" : "translateX(" + b + ")" : this.slider.style[this.originSide] = b
// 		}, j.positionSliderAtSelected = function () {
// 			if (this.cells.length) {
// 				var a = this.cells[this.selectedIndex];
// 				this.x = -a.target, this.positionSlider()
// 			}
// 		}, j.getPositionValue = function (a) {
// 			return this.options.percentPosition ? .01 * Math.round(a / this.size.innerWidth * 1e4) + "%" : Math.round(a) + "px"
// 		}, j.settle = function (a) {
// 			this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * a) || this.restingFrames++, this.restingFrames > 2 && (this.isAnimating = !1, delete this.isFreeScrolling, l && this.positionSlider(), this.dispatchEvent("settle"))
// 		}, j.shiftWrapCells = function (a) {
// 			var b = this.cursorPosition + a;
// 			this._shiftCells(this.beforeShiftCells, b, -1);
// 			var c = this.size.innerWidth - (a + this.slideableWidth + this.cursorPosition);
// 			this._shiftCells(this.afterShiftCells, c, 1)
// 		}, j._shiftCells = function (a, b, c) {
// 			for (var d = 0, e = a.length; e > d; d++) {
// 				var f = a[d],
// 					g = b > 0 ? c : 0;
// 				f.wrapShift(g), b -= f.size.outerWidth
// 			}
// 		}, j._unshiftCells = function (a) {
// 			if (a && a.length)
// 				for (var b = 0, c = a.length; c > b; b++) a[b].wrapShift(0)
// 		}, j.integratePhysics = function () {
// 			this.velocity += this.accel, this.x += this.velocity, this.velocity *= this.getFrictionFactor(), this.accel = 0
// 		}, j.applyForce = function (a) {
// 			this.accel += a
// 		}, j.getFrictionFactor = function () {
// 			return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
// 		}, j.getRestingPosition = function () {
// 			return this.x + this.velocity / (1 - this.getFrictionFactor())
// 		}, j.applyDragForce = function () {
// 			if (this.isPointerDown) {
// 				var a = this.dragX - this.x,
// 					b = a - this.velocity;
// 				this.applyForce(b)
// 			}
// 		}, j.applySelectedAttraction = function () {
// 			var a = this.cells.length;
// 			if (!this.isPointerDown && !this.isFreeScrolling && a) {
// 				var b = this.cells[this.selectedIndex],
// 					c = this.options.wrapAround && a > 1 ? this.slideableWidth * Math.floor(this.selectedIndex / a) : 0,
// 					d = -1 * (b.target + c) - this.x,
// 					e = d * this.options.selectedAttraction;
// 				this.applyForce(e)
// 			}
// 		}, j
// 	}),
// 	function (a, b) {
// 		"use strict";
// 		if ("function" == typeof define && define.amd) define("flickity/js/flickity", ["classie/classie", "eventEmitter/EventEmitter", "eventie/eventie", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./animate"], function (c, d, e, f, g, h, i) {
// 			return b(a, c, d, e, f, g, h, i)
// 		});
// 		else if ("object" == typeof exports) module.exports = b(a, require("desandro-classie"), require("wolfy87-eventemitter"), require("eventie"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./animate"));
// 		else {
// 			var c = a.Flickity;
// 			a.Flickity = b(a, a.classie, a.EventEmitter, a.eventie, a.getSize, a.fizzyUIUtils, c.Cell, c.animatePrototype)
// 		}
// 	}(window, function (a, b, c, d, e, f, g, h) {
// 		function i(a, b) {
// 			for (a = f.makeArray(a); a.length;) b.appendChild(a.shift())
// 		}

// 		function j(a, b) {
// 			var c = f.getQueryElement(a);
// 			return c ? (this.element = c, k && (this.$element = k(this.element)), this.options = f.extend({}, this.constructor.defaults), this.option(b), void this._create()) : void(m && m.error("Bad element for Flickity: " + (c || a)))
// 		}
// 		var k = a.jQuery,
// 			l = a.getComputedStyle,
// 			m = a.console,
// 			n = 0,
// 			o = {};
// 		j.defaults = {
// 			accessibility: !0,
// 			cellAlign: "center",
// 			freeScrollFriction: .075,
// 			friction: .28,
// 			percentPosition: !0,
// 			resize: !0,
// 			selectedAttraction: .025,
// 			setGallerySize: !0
// 		}, j.createMethods = [], f.extend(j.prototype, c.prototype), j.prototype._create = function () {
// 			var b = this.guid = ++n;
// 			this.element.flickityGUID = b, o[b] = this, this.selectedIndex = 0, this.restingFrames = 0, this.x = 0, this.velocity = 0, this.accel = 0, this.originSide = this.options.rightToLeft ? "right" : "left", this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", j.setUnselectable(this.viewport), this._createSlider(), (this.options.resize || this.options.watchCSS) && (d.bind(a, "resize", this), this.isResizeBound = !0);
// 			for (var c = 0, e = j.createMethods.length; e > c; c++) {
// 				var f = j.createMethods[c];
// 				this[f]()
// 			}
// 			this.options.watchCSS ? this.watchCSS() : this.activate()
// 		}, j.prototype.option = function (a) {
// 			f.extend(this.options, a)
// 		}, j.prototype.activate = function () {
// 			if (!this.isActive) {
// 				this.isActive = !0, b.add(this.element, "flickity-enabled"), this.options.rightToLeft && b.add(this.element, "flickity-rtl"), this.getSize();
// 				var a = this._filterFindCellElements(this.element.children);
// 				i(a, this.slider), this.viewport.appendChild(this.slider), this.element.appendChild(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, d.bind(this.element, "keydown", this)), this.emit("activate");
// 				var c, e = this.options.initialIndex;
// 				c = this.isInitActivated ? this.selectedIndex : void 0 !== e && this.cells[e] ? e : 0, this.select(c, !1, !0), this.isInitActivated = !0
// 			}
// 		}, j.prototype._createSlider = function () {
// 			var a = document.createElement("div");
// 			a.className = "flickity-slider", a.style[this.originSide] = 0, this.slider = a
// 		}, j.prototype._filterFindCellElements = function (a) {
// 			return f.filterFindElements(a, this.options.cellSelector)
// 		}, j.prototype.reloadCells = function () {
// 			this.cells = this._makeCells(this.slider.children), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize()
// 		}, j.prototype._makeCells = function (a) {
// 			for (var b = this._filterFindCellElements(a), c = [], d = 0, e = b.length; e > d; d++) {
// 				var f = b[d],
// 					h = new g(f, this);
// 				c.push(h)
// 			}
// 			return c
// 		}, j.prototype.getLastCell = function () {
// 			return this.cells[this.cells.length - 1]
// 		}, j.prototype.positionCells = function () {
// 			this._sizeCells(this.cells), this._positionCells(0)
// 		}, j.prototype._positionCells = function (a) {
// 			a = a || 0, this.maxCellHeight = a ? this.maxCellHeight || 0 : 0;
// 			var b = 0;
// 			if (a > 0) {
// 				var c = this.cells[a - 1];
// 				b = c.x + c.size.outerWidth
// 			}
// 			for (var d, e = this.cells.length, f = a; e > f; f++) d = this.cells[f], d.setPosition(b), b += d.size.outerWidth, this.maxCellHeight = Math.max(d.size.outerHeight, this.maxCellHeight);
// 			this.slideableWidth = b, this._containCells()
// 		}, j.prototype._sizeCells = function (a) {
// 			for (var b = 0, c = a.length; c > b; b++) {
// 				var d = a[b];
// 				d.getSize()
// 			}
// 		}, j.prototype._init = j.prototype.reposition = function () {
// 			this.positionCells(), this.positionSliderAtSelected()
// 		}, j.prototype.getSize = function () {
// 			this.size = e(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign
// 		};
// 		var p = {
// 			center: {
// 				left: .5,
// 				right: .5
// 			},
// 			left: {
// 				left: 0,
// 				right: 1
// 			},
// 			right: {
// 				right: 0,
// 				left: 1
// 			}
// 		};
// 		j.prototype.setCellAlign = function () {
// 			var a = p[this.options.cellAlign];
// 			this.cellAlign = a ? a[this.originSide] : this.options.cellAlign
// 		}, j.prototype.setGallerySize = function () {
// 			this.options.setGallerySize && (this.viewport.style.height = this.maxCellHeight + "px")
// 		}, j.prototype._getWrapShiftCells = function () {
// 			if (this.options.wrapAround) {
// 				this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
// 				var a = this.cursorPosition,
// 					b = this.cells.length - 1;
// 				this.beforeShiftCells = this._getGapCells(a, b, -1), a = this.size.innerWidth - this.cursorPosition, this.afterShiftCells = this._getGapCells(a, 0, 1)
// 			}
// 		}, j.prototype._getGapCells = function (a, b, c) {
// 			for (var d = []; a > 0;) {
// 				var e = this.cells[b];
// 				if (!e) break;
// 				d.push(e), b += c, a -= e.size.outerWidth
// 			}
// 			return d
// 		}, j.prototype._containCells = function () {
// 			if (this.options.contain && !this.options.wrapAround && this.cells.length)
// 				for (var a = this.options.rightToLeft ? "marginRight" : "marginLeft", b = this.options.rightToLeft ? "marginLeft" : "marginRight", c = this.cells[0].size[a], d = this.getLastCell(), e = this.slideableWidth - d.size[b], f = e - this.size.innerWidth * (1 - this.cellAlign), g = e < this.size.innerWidth, h = 0, i = this.cells.length; i > h; h++) {
// 					var j = this.cells[h];
// 					j.setDefaultTarget(), g ? j.target = e * this.cellAlign : (j.target = Math.max(j.target, this.cursorPosition + c), j.target = Math.min(j.target, f))
// 				}
// 		}, j.prototype.dispatchEvent = function (a, b, c) {
// 			var d = [b].concat(c);
// 			if (this.emitEvent(a, d), k && this.$element)
// 				if (b) {
// 					var e = k.Event(b);
// 					e.type = a, this.$element.trigger(e, c)
// 				} else this.$element.trigger(a, c)
// 		}, j.prototype.select = function (a, b, c) {
// 			if (this.isActive) {
// 				a = parseInt(a, 10);
// 				var d = this.cells.length;
// 				this.options.wrapAround && d > 1 && (0 > a ? this.x -= this.slideableWidth : a >= d && (this.x += this.slideableWidth)), (this.options.wrapAround || b) && (a = f.modulo(a, d)), this.cells[a] && (this.selectedIndex = a, this.setSelectedCell(), c ? this.positionSliderAtSelected() : this.startAnimation(), this.dispatchEvent("cellSelect"))
// 			}
// 		}, j.prototype.previous = function (a) {
// 			this.select(this.selectedIndex - 1, a)
// 		}, j.prototype.next = function (a) {
// 			this.select(this.selectedIndex + 1, a)
// 		}, j.prototype.setSelectedCell = function () {
// 			this._removeSelectedCellClass(), this.selectedCell = this.cells[this.selectedIndex], this.selectedElement = this.selectedCell.element, b.add(this.selectedElement, "is-selected")
// 		}, j.prototype._removeSelectedCellClass = function () {
// 			this.selectedCell && b.remove(this.selectedCell.element, "is-selected")
// 		}, j.prototype.getCell = function (a) {
// 			for (var b = 0, c = this.cells.length; c > b; b++) {
// 				var d = this.cells[b];
// 				if (d.element == a) return d
// 			}
// 		}, j.prototype.getCells = function (a) {
// 			a = f.makeArray(a);
// 			for (var b = [], c = 0, d = a.length; d > c; c++) {
// 				var e = a[c],
// 					g = this.getCell(e);
// 				g && b.push(g)
// 			}
// 			return b
// 		}, j.prototype.getCellElements = function () {
// 			for (var a = [], b = 0, c = this.cells.length; c > b; b++) a.push(this.cells[b].element);
// 			return a
// 		}, j.prototype.getParentCell = function (a) {
// 			var b = this.getCell(a);
// 			return b ? b : (a = f.getParent(a, ".flickity-slider > *"), this.getCell(a))
// 		}, j.prototype.getAdjacentCellElements = function (a, b) {
// 			if (!a) return [this.selectedElement];
// 			b = void 0 === b ? this.selectedIndex : b;
// 			var c = this.cells.length;
// 			if (1 + 2 * a >= c) return this.getCellElements();
// 			for (var d = [], e = b - a; b + a >= e; e++) {
// 				var g = this.options.wrapAround ? f.modulo(e, c) : e,
// 					h = this.cells[g];
// 				h && d.push(h.element)
// 			}
// 			return d
// 		}, j.prototype.uiChange = function () {
// 			//this.emit("uiChange")
// 		}, j.prototype.childUIPointerDown = function (a) {
// 			this.emitEvent("childUIPointerDown", [a])
// 		}, j.prototype.onresize = function () {
// 			this.watchCSS(), this.resize()
// 		}, f.debounceMethod(j, "onresize", 150), j.prototype.resize = function () {
// 			this.isActive && (this.getSize(), this.options.wrapAround && (this.x = f.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.positionSliderAtSelected())
// 		};
// 		var q = j.supportsConditionalCSS = function () {
// 			var a;
// 			return function () {
// 				if (void 0 !== a) return a;
// 				if (!l) return void(a = !1);
// 				var b = document.createElement("style"),
// 					c = document.createTextNode('body:after { content: "foo"; display: none; }');
// 				b.appendChild(c), document.head.appendChild(b);
// 				var d = l(document.body, ":after").content;
// 				return a = -1 != d.indexOf("foo"), document.head.removeChild(b), a
// 			}
// 		}();
// 		j.prototype.watchCSS = function () {
// 			var a = this.options.watchCSS;
// 			if (a) {
// 				var b = q();
// 				if (!b) {
// 					var c = "fallbackOn" == a ? "activate" : "deactivate";
// 					return void this[c]()
// 				}
// 				var d = l(this.element, ":after").content; - 1 != d.indexOf("flickity") ? this.activate() : this.deactivate()
// 			}
// 		}, j.prototype.onkeydown = function (a) {
// 			if (this.options.accessibility && (!document.activeElement || document.activeElement == this.element))
// 				if (37 == a.keyCode) {
// 					var b = this.options.rightToLeft ? "next" : "previous";
// 					this.uiChange(), this[b]()
// 				} else if (39 == a.keyCode) {
// 				var c = this.options.rightToLeft ? "previous" : "next";
// 				this.uiChange(), this[c]()
// 			}
// 		}, j.prototype.deactivate = function () {
// 			if (this.isActive) {
// 				b.remove(this.element, "flickity-enabled"), b.remove(this.element, "flickity-rtl");
// 				for (var a = 0, c = this.cells.length; c > a; a++) {
// 					var e = this.cells[a];
// 					e.destroy()
// 				}
// 				this._removeSelectedCellClass(), this.element.removeChild(this.viewport), i(this.slider.children, this.element), this.options.accessibility && (this.element.removeAttribute("tabIndex"), d.unbind(this.element, "keydown", this)), this.isActive = !1, this.emit("deactivate")
// 			}
// 		}, j.prototype.destroy = function () {
// 			this.deactivate(), this.isResizeBound && d.unbind(a, "resize", this), this.emit("destroy"), k && this.$element && k.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete o[this.guid]
// 		}, f.extend(j.prototype, h);
// 		var r = "attachEvent" in a;
// 		return j.setUnselectable = function (a) {
// 			r && a.setAttribute("unselectable", "on")
// 		}, j.data = function (a) {
// 			a = f.getQueryElement(a);
// 			var b = a && a.flickityGUID;
// 			return b && o[b]
// 		}, f.htmlInit(j, "flickity"), k && k.bridget && k.bridget("flickity", j), j.Cell = g, j
// 	}),
// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define("unipointer/unipointer", ["eventEmitter/EventEmitter", "eventie/eventie"], function (c, d) {
// 			return b(a, c, d)
// 		}) : "object" == typeof exports ? module.exports = b(a, require("wolfy87-eventemitter"), require("eventie")) : a.Unipointer = b(a, a.EventEmitter, a.eventie)
// 	}(window, function (a, b, c) {
// 		function d() {}

// 		function e() {}
// 		e.prototype = new b, e.prototype.bindStartEvent = function (a) {
// 			this._bindStartEvent(a, !0)
// 		}, e.prototype.unbindStartEvent = function (a) {
// 			this._bindStartEvent(a, !1)
// 		}, e.prototype._bindStartEvent = function (b, d) {
// 			d = void 0 === d ? !0 : !!d;
// 			var e = d ? "bind" : "unbind";
// 			a.navigator.pointerEnabled ? c[e](b, "pointerdown", this) : a.navigator.msPointerEnabled ? c[e](b, "MSPointerDown", this) : (c[e](b, "mousedown", this), c[e](b, "touchstart", this))
// 		}, e.prototype.handleEvent = function (a) {
// 			var b = "on" + a.type;
// 			this[b] && this[b](a)
// 		}, e.prototype.getTouch = function (a) {
// 			for (var b = 0, c = a.length; c > b; b++) {
// 				var d = a[b];
// 				if (d.identifier == this.pointerIdentifier) return d
// 			}
// 		}, e.prototype.onmousedown = function (a) {
// 			var b = a.button;
// 			b && 0 !== b && 1 !== b || this._pointerDown(a, a)
// 		}, e.prototype.ontouchstart = function (a) {
// 			this._pointerDown(a, a.changedTouches[0])
// 		}, e.prototype.onMSPointerDown = e.prototype.onpointerdown = function (a) {
// 			this._pointerDown(a, a)
// 		}, e.prototype._pointerDown = function (a, b) {
// 			this.isPointerDown || (this.isPointerDown = !0, this.pointerIdentifier = void 0 !== b.pointerId ? b.pointerId : b.identifier, this.pointerDown(a, b))
// 		}, e.prototype.pointerDown = function (a, b) {
// 			this._bindPostStartEvents(a), this.emitEvent("pointerDown", [a, b])
// 		};
// 		var f = {
// 			mousedown: ["mousemove", "mouseup"],
// 			touchstart: ["touchmove", "touchend", "touchcancel"],
// 			pointerdown: ["pointermove", "pointerup", "pointercancel"],
// 			MSPointerDown: ["MSPointerMove", "MSPointerUp", "MSPointerCancel"]
// 		};
// 		return e.prototype._bindPostStartEvents = function (b) {
// 			if (b) {
// 				for (var d = f[b.type], e = b.preventDefault ? a : document, g = 0, h = d.length; h > g; g++) {
// 					var i = d[g];
// 					c.bind(e, i, this)
// 				}
// 				this._boundPointerEvents = {
// 					events: d,
// 					node: e
// 				}
// 			}
// 		}, e.prototype._unbindPostStartEvents = function () {
// 			var a = this._boundPointerEvents;
// 			if (a && a.events) {
// 				for (var b = 0, d = a.events.length; d > b; b++) {
// 					var e = a.events[b];
// 					c.unbind(a.node, e, this)
// 				}
// 				delete this._boundPointerEvents
// 			}
// 		}, e.prototype.onmousemove = function (a) {
// 			this._pointerMove(a, a)
// 		}, e.prototype.onMSPointerMove = e.prototype.onpointermove = function (a) {
// 			a.pointerId == this.pointerIdentifier && this._pointerMove(a, a)
// 		}, e.prototype.ontouchmove = function (a) {
// 			var b = this.getTouch(a.changedTouches);
// 			b && this._pointerMove(a, b)
// 		}, e.prototype._pointerMove = function (a, b) {
// 			this.pointerMove(a, b)
// 		}, e.prototype.pointerMove = function (a, b) {
// 			this.emitEvent("pointerMove", [a, b])
// 		}, e.prototype.onmouseup = function (a) {
// 			this._pointerUp(a, a)
// 		}, e.prototype.onMSPointerUp = e.prototype.onpointerup = function (a) {
// 			a.pointerId == this.pointerIdentifier && this._pointerUp(a, a)
// 		}, e.prototype.ontouchend = function (a) {
// 			var b = this.getTouch(a.changedTouches);
// 			b && this._pointerUp(a, b)
// 		}, e.prototype._pointerUp = function (a, b) {
// 			this._pointerDone(), this.pointerUp(a, b)
// 		}, e.prototype.pointerUp = function (a, b) {
// 			this.emitEvent("pointerUp", [a, b])
// 		}, e.prototype._pointerDone = function () {
// 			this.isPointerDown = !1, delete this.pointerIdentifier, this._unbindPostStartEvents(), this.pointerDone()
// 		}, e.prototype.pointerDone = d, e.prototype.onMSPointerCancel = e.prototype.onpointercancel = function (a) {
// 			a.pointerId == this.pointerIdentifier && this._pointerCancel(a, a)
// 		}, e.prototype.ontouchcancel = function (a) {
// 			var b = this.getTouch(a.changedTouches);
// 			b && this._pointerCancel(a, b)
// 		}, e.prototype._pointerCancel = function (a, b) {
// 			this._pointerDone(), this.pointerCancel(a, b)
// 		}, e.prototype.pointerCancel = function (a, b) {
// 			this.emitEvent("pointerCancel", [a, b])
// 		}, e.getPointerPoint = function (a) {
// 			return {
// 				x: void 0 !== a.pageX ? a.pageX : a.clientX,
// 				y: void 0 !== a.pageY ? a.pageY : a.clientY
// 			}
// 		}, e
// 	}),
// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define("unidragger/unidragger", ["eventie/eventie", "unipointer/unipointer"], function (c, d) {
// 			return b(a, c, d)
// 		}) : "object" == typeof exports ? module.exports = b(a, require("eventie"), require("unipointer")) : a.Unidragger = b(a, a.eventie, a.Unipointer)
// 	}(window, function (a, b, c) {
// 		function d() {}

// 		function e(a) {
// 			a.preventDefault ? a.preventDefault() : a.returnValue = !1
// 		}

// 		function f() {}

// 		function g() {
// 			return !1
// 		}
// 		f.prototype = new c, f.prototype.bindHandles = function () {
// 			this._bindHandles(!0)
// 		}, f.prototype.unbindHandles = function () {
// 			this._bindHandles(!1)
// 		};
// 		var h = a.navigator;
// 		f.prototype._bindHandles = function (a) {
// 			a = void 0 === a ? !0 : !!a;
// 			var c;
// 			c = h.pointerEnabled ? function (b) {
// 				b.style.touchAction = a ? "none" : ""
// 			} : h.msPointerEnabled ? function (b) {
// 				b.style.msTouchAction = a ? "none" : ""
// 			} : function () {
// 				a && j(g)
// 			};
// 			for (var d = a ? "bind" : "unbind", e = 0, f = this.handles.length; f > e; e++) {
// 				var g = this.handles[e];
// 				this._bindStartEvent(g, a), c(g), b[d](g, "click", this)
// 			}
// 		};
// 		var i = "attachEvent" in document.documentElement,
// 			j = i ? function (a) {
// 				"IMG" == a.nodeName && (a.ondragstart = g);
// 				for (var b = a.querySelectorAll("img"), c = 0, d = b.length; d > c; c++) {
// 					var e = b[c];
// 					e.ondragstart = g
// 				}
// 			} : d;
// 		f.prototype.pointerDown = function (c, d) {
// 			if ("INPUT" == c.target.nodeName && "range" == c.target.type) return this.isPointerDown = !1, void delete this.pointerIdentifier;
// 			this._dragPointerDown(c, d);
// 			var e = document.activeElement;
// 			e && e.blur && e.blur(), this._bindPostStartEvents(c), this.pointerDownScroll = f.getScrollPosition(), b.bind(a, "scroll", this), this.emitEvent("pointerDown", [c, d])
// 		}, f.prototype._dragPointerDown = function (a, b) {
// 			this.pointerDownPoint = c.getPointerPoint(b);
// 			var d = "touchstart" == a.type,
// 				f = a.target.nodeName;
// 			d || "SELECT" == f || e(a)
// 		}, f.prototype.pointerMove = function (a, b) {
// 			var c = this._dragPointerMove(a, b);
// 			this.emitEvent("pointerMove", [a, b, c]), this._dragMove(a, b, c)
// 		}, f.prototype._dragPointerMove = function (a, b) {
// 			var d = c.getPointerPoint(b),
// 				e = {
// 					x: d.x - this.pointerDownPoint.x,
// 					y: d.y - this.pointerDownPoint.y
// 				};
// 			return !this.isDragging && this.hasDragStarted(e) && this._dragStart(a, b), e
// 		}, f.prototype.hasDragStarted = function (a) {
// 			return Math.abs(a.x) > 3 || Math.abs(a.y) > 3
// 		}, f.prototype.pointerUp = function (a, b) {
// 			this.emitEvent("pointerUp", [a, b]), this._dragPointerUp(a, b)
// 		}, f.prototype._dragPointerUp = function (a, b) {
// 			this.isDragging ? this._dragEnd(a, b) : this._staticClick(a, b)
// 		}, f.prototype.pointerDone = function () {
// 			b.unbind(a, "scroll", this)
// 		}, f.prototype._dragStart = function (a, b) {
// 			this.isDragging = !0, this.dragStartPoint = f.getPointerPoint(b), this.isPreventingClicks = !0, this.dragStart(a, b)
// 		}, f.prototype.dragStart = function (a, b) {
// 			this.emitEvent("dragStart", [a, b])
// 		}, f.prototype._dragMove = function (a, b, c) {
// 			this.isDragging && this.dragMove(a, b, c)
// 		}, f.prototype.dragMove = function (a, b, c) {
// 			e(a), this.emitEvent("dragMove", [a, b, c])
// 		}, f.prototype._dragEnd = function (a, b) {
// 			this.isDragging = !1;
// 			var c = this;
// 			setTimeout(function () {
// 				delete c.isPreventingClicks
// 			}), this.dragEnd(a, b)
// 		}, f.prototype.dragEnd = function (a, b) {
// 			this.emitEvent("dragEnd", [a, b])
// 		}, f.prototype.pointerDone = function () {
// 			b.unbind(a, "scroll", this), delete this.pointerDownScroll
// 		}, f.prototype.onclick = function (a) {
// 			this.isPreventingClicks && e(a)
// 		}, f.prototype._staticClick = function (a, b) {
// 			if (!this.isIgnoringMouseUp || "mouseup" != a.type) {
// 				var c = a.target.nodeName;
// 				if ("INPUT" != c && "TEXTAREA" != c || a.target.focus(), this.staticClick(a, b), "mouseup" != a.type) {
// 					this.isIgnoringMouseUp = !0;
// 					var d = this;
// 					setTimeout(function () {
// 						delete d.isIgnoringMouseUp
// 					}, 400)
// 				}
// 			}
// 		}, f.prototype.staticClick = function (a, b) {
// 			this.emitEvent("staticClick", [a, b])
// 		}, f.prototype.onscroll = function () {
// 			var a = f.getScrollPosition(),
// 				b = this.pointerDownScroll.x - a.x,
// 				c = this.pointerDownScroll.y - a.y;
// 			(Math.abs(b) > 3 || Math.abs(c) > 3) && this._pointerDone()
// 		}, f.getPointerPoint = function (a) {
// 			return {
// 				x: void 0 !== a.pageX ? a.pageX : a.clientX,
// 				y: void 0 !== a.pageY ? a.pageY : a.clientY
// 			}
// 		};
// 		var k = void 0 !== a.pageYOffset;
// 		return f.getScrollPosition = function () {
// 			return {
// 				x: k ? a.pageXOffset : document.body.scrollLeft,
// 				y: k ? a.pageYOffset : document.body.scrollTop
// 			}
// 		}, f.getPointerPoint = c.getPointerPoint, f
// 	}),
// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define("flickity/js/drag", ["classie/classie", "eventie/eventie", "./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function (c, d, e, f, g) {
// 			return b(a, c, d, e, f, g)
// 		}) : "object" == typeof exports ? module.exports = b(a, require("desandro-classie"), require("eventie"), require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : a.Flickity = b(a, a.classie, a.eventie, a.Flickity, a.Unidragger, a.fizzyUIUtils)
// 	}(window, function (a, b, c, d, e, f) {
// 		function g(a) {
// 			a.preventDefault ? a.preventDefault() : a.returnValue = !1
// 		}
// 		f.extend(d.defaults, {
// 			draggable: !0
// 		}), d.createMethods.push("_createDrag"), f.extend(d.prototype, e.prototype), d.prototype._createDrag = function () {
// 			this.on("activate", this.bindDrag), this.on("uiChange", this._uiChangeDrag), this.on("childUIPointerDown", this._childUIPointerDownDrag), this.on("deactivate", this.unbindDrag)
// 		}, d.prototype.bindDrag = function () {
// 			this.options.draggable && !this.isDragBound && (b.add(this.element, "is-draggable"), this.handles = [this.viewport], this.bindHandles(), this.isDragBound = !0)
// 		}, d.prototype.unbindDrag = function () {
// 			this.isDragBound && (b.remove(this.element, "is-draggable"), this.unbindHandles(), delete this.isDragBound)
// 		}, d.prototype._uiChangeDrag = function () {
// 			delete this.isFreeScrolling
// 		}, d.prototype._childUIPointerDownDrag = function (a) {
// 			g(a), this.pointerDownFocus(a)
// 		}, d.prototype.pointerDown = function (d, f) {
// 			if ("INPUT" == d.target.nodeName && "range" == d.target.type) return this.isPointerDown = !1, void delete this.pointerIdentifier;
// 			this._dragPointerDown(d, f);
// 			var g = document.activeElement;
// 			g && g.blur && g != this.element && g != document.body && g.blur(), this.pointerDownFocus(d), this.dragX = this.x, b.add(this.viewport, "is-pointer-down"), this._bindPostStartEvents(d), this.pointerDownScroll = e.getScrollPosition(), c.bind(a, "scroll", this), this.dispatchEvent("pointerDown", d, [f])
// 		};
// 		var h = {
// 				touchstart: !0,
// 				MSPointerDown: !0
// 			},
// 			i = {
// 				INPUT: !0,
// 				SELECT: !0
// 			};
// 		return d.prototype.pointerDownFocus = function (b) {
// 			if (this.options.accessibility && !h[b.type] && !i[b.target.nodeName]) {
// 				var c = a.pageYOffset;
// 				this.element.focus(), a.pageYOffset != c && a.scrollTo(a.pageXOffset, c)
// 			}
// 		}, d.prototype.hasDragStarted = function (a) {
// 			return Math.abs(a.x) > 3
// 		}, d.prototype.pointerUp = function (a, c) {
// 			b.remove(this.viewport, "is-pointer-down"), this.dispatchEvent("pointerUp", a, [c]), this._dragPointerUp(a, c)
// 		}, d.prototype.pointerDone = function () {
// 			c.unbind(a, "scroll", this), delete this.pointerDownScroll
// 		}, d.prototype.dragStart = function (a, b) {
// 			this.dragStartPosition = this.x, this.startAnimation(), this.dispatchEvent("dragStart", a, [b])
// 		}, d.prototype.dragMove = function (a, b, c) {
// 			g(a), this.previousDragX = this.dragX;
// 			var d = this.options.rightToLeft ? -1 : 1,
// 				e = this.dragStartPosition + c.x * d;
// 			if (!this.options.wrapAround && this.cells.length) {
// 				var f = Math.max(-this.cells[0].target, this.dragStartPosition);
// 				e = e > f ? .5 * (e + f) : e;
// 				var h = Math.min(-this.getLastCell().target, this.dragStartPosition);
// 				e = h > e ? .5 * (e + h) : e
// 			}
// 			this.dragX = e, this.dragMoveTime = new Date, this.dispatchEvent("dragMove", a, [b, c])
// 		}, d.prototype.dragEnd = function (a, b) {
// 			this.options.freeScroll && (this.isFreeScrolling = !0);
// 			var c = this.dragEndRestingSelect();
// 			if (this.options.freeScroll && !this.options.wrapAround) {
// 				var d = this.getRestingPosition();
// 				this.isFreeScrolling = -d > this.cells[0].target && -d < this.getLastCell().target
// 			} else this.options.freeScroll || c != this.selectedIndex || (c += this.dragEndBoostSelect());
// 			delete this.previousDragX, this.select(c), this.dispatchEvent("dragEnd", a, [b])
// 		}, d.prototype.dragEndRestingSelect = function () {
// 			var a = this.getRestingPosition(),
// 				b = Math.abs(this.getCellDistance(-a, this.selectedIndex)),
// 				c = this._getClosestResting(a, b, 1),
// 				d = this._getClosestResting(a, b, -1),
// 				e = c.distance < d.distance ? c.index : d.index;
// 			return e
// 		}, d.prototype._getClosestResting = function (a, b, c) {
// 			for (var d = this.selectedIndex, e = 1 / 0, f = this.options.contain && !this.options.wrapAround ? function (a, b) {
// 					return b >= a
// 				} : function (a, b) {
// 					return b > a
// 				}; f(b, e) && (d += c, e = b, b = this.getCellDistance(-a, d), null !== b);) b = Math.abs(b);
// 			return {
// 				distance: e,
// 				index: d - c
// 			}
// 		}, d.prototype.getCellDistance = function (a, b) {
// 			var c = this.cells.length,
// 				d = this.options.wrapAround && c > 1,
// 				e = d ? f.modulo(b, c) : b,
// 				g = this.cells[e];
// 			if (!g) return null;
// 			var h = d ? this.slideableWidth * Math.floor(b / c) : 0;
// 			return a - (g.target + h)
// 		}, d.prototype.dragEndBoostSelect = function () {
// 			if (void 0 === this.previousDragX || !this.dragMoveTime || new Date - this.dragMoveTime > 100) return 0;
// 			var a = this.getCellDistance(-this.dragX, this.selectedIndex),
// 				b = this.previousDragX - this.dragX;
// 			return a > 0 && b > 0 ? 1 : 0 > a && 0 > b ? -1 : 0
// 		}, d.prototype.staticClick = function (a, b) {
// 			var c = this.getParentCell(a.target),
// 				d = c && c.element,
// 				e = c && f.indexOf(this.cells, c);
// 			this.dispatchEvent("staticClick", a, [b, d, e])
// 		}, d
// 	}),
// 	function (a, b) {
// 		"function" == typeof define && define.amd ? define("tap-listener/tap-listener", ["unipointer/unipointer"], function (c) {
// 			return b(a, c)
// 		}) : "object" == typeof exports ? module.exports = b(a, require("unipointer")) : a.TapListener = b(a, a.Unipointer)
// 	}(window, function (a, b) {
// 		function c(a) {
// 			this.bindTap(a)
// 		}
// 		c.prototype = new b, c.prototype.bindTap = function (a) {
// 			a && (this.unbindTap(), this.tapElement = a, this._bindStartEvent(a, !0))
// 		}, c.prototype.unbindTap = function () {
// 			this.tapElement && (this._bindStartEvent(this.tapElement, !0), delete this.tapElement)
// 		};
// 		var d = void 0 !== a.pageYOffset;
// 		return c.prototype.pointerUp = function (c, e) {
// 			if (!this.isIgnoringMouseUp || "mouseup" != c.type) {
// 				var f = b.getPointerPoint(e),
// 					g = this.tapElement.getBoundingClientRect(),
// 					h = d ? a.pageXOffset : document.body.scrollLeft,
// 					i = d ? a.pageYOffset : document.body.scrollTop,
// 					j = f.x >= g.left + h && f.x <= g.right + h && f.y >= g.top + i && f.y <= g.bottom + i;
// 				j && this.emitEvent("tap", [c, e]), "mouseup" != c.type && (this.isIgnoringMouseUp = !0, setTimeout(function () {
// 					delete this.isIgnoringMouseUp
// 				}.bind(this), 320))
// 			}
// 		}, c.prototype.destroy = function () {
// 			this.pointerDone(), this.unbindTap()
// 		}, c
// 	}),
// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define("flickity/js/prev-next-button", ["eventie/eventie", "./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function (c, d, e, f) {
// 			return b(a, c, d, e, f)
// 		}) : "object" == typeof exports ? module.exports = b(a, require("eventie"), require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : b(a, a.eventie, a.Flickity, a.TapListener, a.fizzyUIUtils)
// 	}(window, function (a, b, c, d, e) {
// 		function f(a, b) {
// 			this.direction = a, this.parent = b, this._create()
// 		}

// 		function g(a) {
// 			return "string" == typeof a ? a : "M " + a.x0 + ",50 L " + a.x1 + "," + (a.y1 + 50) + " L " + a.x2 + "," + (a.y2 + 50) + " L " + a.x3 + ",50  L " + a.x2 + "," + (50 - a.y2) + " L " + a.x1 + "," + (50 - a.y1) + " Z"
// 		}
// 		var h = "http://www.w3.org/2000/svg",
// 			i = function () {
// 				function a() {
// 					if (void 0 !== b) return b;
// 					var a = document.createElement("div");
// 					return a.innerHTML = "<svg/>", b = (a.firstChild && a.firstChild.namespaceURI) == h
// 				}
// 				var b;
// 				return a
// 			}();
// 		return f.prototype = new d, f.prototype._create = function () {
// 			this.isEnabled = !0, this.isPrevious = -1 == this.direction;
// 			var a = this.parent.options.rightToLeft ? 1 : -1;
// 			this.isLeft = this.direction == a;
// 			var b = this.element = document.createElement("button");
// 			if (b.className = "flickity-prev-next-button", b.className += this.isPrevious ? " previous" : " next", b.setAttribute("type", "button"), this.disable(), b.setAttribute("aria-label", this.isPrevious ? "previous" : "next"), c.setUnselectable(b), i()) {
// 				var d = this.createSVG();
// 				b.appendChild(d)
// 			} else this.setArrowText(), b.className += " no-svg";
// 			var e = this;
// 			this.onCellSelect = function () {
// 				e.update()
// 			}, this.parent.on("cellSelect", this.onCellSelect), this.on("tap", this.onTap), this.on("pointerDown", function (a, b) {
// 				e.parent.childUIPointerDown(b)
// 			})
// 		}, f.prototype.activate = function () {
// 			this.bindTap(this.element), b.bind(this.element, "click", this), this.parent.element.appendChild(this.element)
// 		}, f.prototype.deactivate = function () {
// 			this.parent.element.removeChild(this.element), d.prototype.destroy.call(this), b.unbind(this.element, "click", this)
// 		}, f.prototype.createSVG = function () {
// 			var a = document.createElementNS(h, "svg");
// 			a.setAttribute("viewBox", "0 0 100 100");
// 			var b = document.createElementNS(h, "path"),
// 				c = g(this.parent.options.arrowShape);
// 			return b.setAttribute("d", c), b.setAttribute("class", "arrow"), this.isLeft || b.setAttribute("transform", "translate(100, 100) rotate(180) "), a.appendChild(b), a
// 		}, f.prototype.setArrowText = function () {
// 			var a = this.parent.options,
// 				b = this.isLeft ? a.leftArrowText : a.rightArrowText;
// 			e.setText(this.element, b)
// 		}, f.prototype.onTap = function () {
// 			if (this.isEnabled) {
// 				this.parent.uiChange();
// 				var a = this.isPrevious ? "previous" : "next";
// 				this.parent[a]()
// 			}
// 		}, f.prototype.handleEvent = e.handleEvent, f.prototype.onclick = function () {
// 			var a = document.activeElement;
// 			a && a == this.element && this.onTap()
// 		}, f.prototype.enable = function () {
// 			this.isEnabled || (this.element.disabled = !1, this.isEnabled = !0)
// 		}, f.prototype.disable = function () {
// 			this.isEnabled && (this.element.disabled = !0, this.isEnabled = !1)
// 		}, f.prototype.update = function () {
// 			var a = this.parent.cells;
// 			if (this.parent.options.wrapAround && a.length > 1) return void this.enable();
// 			var b = a.length ? a.length - 1 : 0,
// 				c = this.isPrevious ? 0 : b,
// 				d = this.parent.selectedIndex == c ? "disable" : "enable";
// 			this[d]()
// 		}, f.prototype.destroy = function () {
// 			this.deactivate()
// 		}, e.extend(c.defaults, {
// 			prevNextButtons: !0,
// 			leftArrowText: "â€¹",
// 			rightArrowText: "â€º",
// 			arrowShape: {
// 				x0: 10,
// 				x1: 60,
// 				y1: 50,
// 				x2: 70,
// 				y2: 40,
// 				x3: 30
// 			}
// 		}), c.createMethods.push("_createPrevNextButtons"), c.prototype._createPrevNextButtons = function () {
// 			this.options.prevNextButtons && (this.prevButton = new f(-1, this), this.nextButton = new f(1, this), this.on("activate", this.activatePrevNextButtons))
// 		}, c.prototype.activatePrevNextButtons = function () {
// 			this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons)
// 		}, c.prototype.deactivatePrevNextButtons = function () {
// 			this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons)
// 		}, c.PrevNextButton = f, c
// 	}),
// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define("flickity/js/page-dots", ["eventie/eventie", "./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function (c, d, e, f) {
// 			return b(a, c, d, e, f)
// 		}) : "object" == typeof exports ? module.exports = b(a, require("eventie"), require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : b(a, a.eventie, a.Flickity, a.TapListener, a.fizzyUIUtils)
// 	}(window, function (a, b, c, d, e) {
// 		function f(a) {
// 			this.parent = a, this._create()
// 		}
// 		return f.prototype = new d, f.prototype._create = function () {
// 			this.holder = document.createElement("ol"), this.holder.className = "flickity-page-dots", c.setUnselectable(this.holder), this.dots = [];
// 			var a = this;
// 			this.onCellSelect = function () {
// 				a.updateSelected()
// 			}, this.parent.on("cellSelect", this.onCellSelect), this.on("tap", this.onTap), this.on("pointerDown", function (b, c) {
// 				a.parent.childUIPointerDown(c)
// 			})
// 		}, f.prototype.activate = function () {
// 			this.setDots(), this.bindTap(this.holder), this.parent.element.appendChild(this.holder)
// 		}, f.prototype.deactivate = function () {
// 			this.parent.element.removeChild(this.holder), d.prototype.destroy.call(this)
// 		}, f.prototype.setDots = function () {
// 			var a = this.parent.cells.length - this.dots.length;
// 			a > 0 ? this.addDots(a) : 0 > a && this.removeDots(-a)
// 		}, f.prototype.addDots = function (a) {
// 			for (var b = document.createDocumentFragment(), c = []; a;) {
// 				var d = document.createElement("li");
// 				d.className = "dot", b.appendChild(d), c.push(d), a--
// 			}
// 			this.holder.appendChild(b), this.dots = this.dots.concat(c)
// 		}, f.prototype.removeDots = function (a) {
// 			for (var b = this.dots.splice(this.dots.length - a, a), c = 0, d = b.length; d > c; c++) {
// 				var e = b[c];
// 				this.holder.removeChild(e)
// 			}
// 		}, f.prototype.updateSelected = function () {
// 			this.selectedDot && (this.selectedDot.className = "dot"), this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex], this.selectedDot.className = "dot is-selected")
// 		}, f.prototype.onTap = function (a) {
// 			var b = a.target;
// 			if ("LI" == b.nodeName) {
// 				this.parent.uiChange();
// 				var c = e.indexOf(this.dots, b);
// 				this.parent.select(c)
// 			}
// 		}, f.prototype.destroy = function () {
// 			this.deactivate()
// 		}, c.PageDots = f, e.extend(c.defaults, {
// 			pageDots: !0
// 		}), c.createMethods.push("_createPageDots"), c.prototype._createPageDots = function () {
// 			this.options.pageDots && (this.pageDots = new f(this), this.on("activate", this.activatePageDots), this.on("cellAddedRemoved", this.onCellAddedRemovedPageDots), this.on("deactivate", this.deactivatePageDots))
// 		}, c.prototype.activatePageDots = function () {
// 			this.pageDots.activate()
// 		}, c.prototype.onCellAddedRemovedPageDots = function () {
// 			this.pageDots.setDots()
// 		}, c.prototype.deactivatePageDots = function () {
// 			this.pageDots.deactivate()
// 		}, c.PageDots = f, c
// 	}),
// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define("flickity/js/player", ["eventEmitter/EventEmitter", "eventie/eventie", "fizzy-ui-utils/utils", "./flickity"], function (a, c, d, e) {
// 			return b(a, c, d, e)
// 		}) : "object" == typeof exports ? module.exports = b(require("wolfy87-eventemitter"), require("eventie"), require("fizzy-ui-utils"), require("./flickity")) : b(a.EventEmitter, a.eventie, a.fizzyUIUtils, a.Flickity)
// 	}(window, function (a, b, c, d) {
// 		function e(a) {
// 			if (this.parent = a, this.state = "stopped", g) {
// 				var b = this;
// 				this.onVisibilityChange = function () {
// 					b.visibilityChange()
// 				}
// 			}
// 		}
// 		var f, g;
// 		return "hidden" in document ? (f = "hidden", g = "visibilitychange") : "webkitHidden" in document && (f = "webkitHidden", g = "webkitvisibilitychange"), e.prototype = new a, e.prototype.play = function () {
// 			"playing" != this.state && (this.state = "playing", g && document.addEventListener(g, this.onVisibilityChange, !1), this.tick())
// 		}, e.prototype.tick = function () {
// 			if ("playing" == this.state) {
// 				var a = this.parent.options.autoPlay;
// 				a = "number" == typeof a ? a : 3e3;
// 				var b = this;
// 				this.clear(), this.timeout = setTimeout(function () {
// 					b.parent.next(!0), b.tick()
// 				}, a)
// 			}
// 		}, e.prototype.stop = function () {
// 			this.state = "stopped", this.clear(), g && document.removeEventListener(g, this.onVisibilityChange, !1)
// 		}, e.prototype.clear = function () {
// 			clearTimeout(this.timeout)
// 		}, e.prototype.pause = function () {
// 			"playing" == this.state && (this.state = "paused", this.clear())
// 		}, e.prototype.unpause = function () {
// 			"paused" == this.state && this.play()
// 		}, e.prototype.visibilityChange = function () {
// 			var a = document[f];
// 			this[a ? "pause" : "unpause"]()
// 		}, c.extend(d.defaults, {
// 			pauseAutoPlayOnHover: !0
// 		}), d.createMethods.push("_createPlayer"), d.prototype._createPlayer = function () {
// 			this.player = new e(this), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer)
// 		}, d.prototype.activatePlayer = function () {
// 			this.options.autoPlay && (this.player.play(), b.bind(this.element, "mouseenter", this), this.isMouseenterBound = !0)
// 		}, d.prototype.playPlayer = function () {
// 			this.player.play()
// 		}, d.prototype.stopPlayer = function () {
// 			this.player.stop()
// 		}, d.prototype.pausePlayer = function () {
// 			this.player.pause()
// 		}, d.prototype.unpausePlayer = function () {
// 			this.player.unpause()
// 		}, d.prototype.deactivatePlayer = function () {
// 			this.player.stop(), this.isMouseenterBound && (b.unbind(this.element, "mouseenter", this), delete this.isMouseenterBound)
// 		}, d.prototype.onmouseenter = function () {
// 			this.options.pauseAutoPlayOnHover && (this.player.pause(), b.bind(this.element, "mouseleave", this))
// 		}, d.prototype.onmouseleave = function () {
// 			this.player.unpause(), b.unbind(this.element, "mouseleave", this)
// 		}, d.Player = e, d
// 	}),
// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function (c, d) {
// 			return b(a, c, d)
// 		}) : "object" == typeof exports ? module.exports = b(a, require("./flickity"), require("fizzy-ui-utils")) : b(a, a.Flickity, a.fizzyUIUtils)
// 	}(window, function (a, b, c) {
// 		function d(a) {
// 			for (var b = document.createDocumentFragment(), c = 0, d = a.length; d > c; c++) {
// 				var e = a[c];
// 				b.appendChild(e.element)
// 			}
// 			return b
// 		}
// 		return b.prototype.insert = function (a, b) {
// 			var c = this._makeCells(a);
// 			if (c && c.length) {
// 				var e = this.cells.length;
// 				b = void 0 === b ? e : b;
// 				var f = d(c),
// 					g = b == e;
// 				if (g) this.slider.appendChild(f);
// 				else {
// 					var h = this.cells[b].element;
// 					this.slider.insertBefore(f, h)
// 				}
// 				if (0 === b) this.cells = c.concat(this.cells);
// 				else if (g) this.cells = this.cells.concat(c);
// 				else {
// 					var i = this.cells.splice(b, e - b);
// 					this.cells = this.cells.concat(c).concat(i)
// 				}
// 				this._sizeCells(c);
// 				var j = b > this.selectedIndex ? 0 : c.length;
// 				this._cellAddedRemoved(b, j)
// 			}
// 		}, b.prototype.append = function (a) {
// 			this.insert(a, this.cells.length)
// 		}, b.prototype.prepend = function (a) {
// 			this.insert(a, 0)
// 		}, b.prototype.remove = function (a) {
// 			var b, d, e, f = this.getCells(a),
// 				g = 0;
// 			for (b = 0, d = f.length; d > b; b++) {
// 				e = f[b];
// 				var h = c.indexOf(this.cells, e) < this.selectedIndex;
// 				g -= h ? 1 : 0
// 			}
// 			for (b = 0, d = f.length; d > b; b++) e = f[b], e.remove(), c.removeFrom(this.cells, e);
// 			f.length && this._cellAddedRemoved(0, g)
// 		}, b.prototype._cellAddedRemoved = function (a, b) {
// 			b = b || 0, this.selectedIndex += b, this.selectedIndex = Math.max(0, Math.min(this.cells.length - 1, this.selectedIndex)), this.emitEvent("cellAddedRemoved", [a, b]), this.cellChange(a, !0)
// 		}, b.prototype.cellSizeChange = function (a) {
// 			var b = this.getCell(a);
// 			if (b) {
// 				b.getSize();
// 				var d = c.indexOf(this.cells, b);
// 				this.cellChange(d)
// 			}
// 		}, b.prototype.cellChange = function (a, b) {
// 			var c = this.slideableWidth;
// 			if (this._positionCells(a), this._getWrapShiftCells(), this.setGallerySize(), this.options.freeScroll) {
// 				var d = c - this.slideableWidth;
// 				this.x += d * this.cellAlign, this.positionSlider()
// 			} else b && this.positionSliderAtSelected(), this.select(this.selectedIndex)
// 		}, b
// 	}),
	

// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], b) : "object" == typeof exports && (module.exports = b(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")))
// 	}(window, function (a) {
// 		return a
// 	}),
// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define("flickity-as-nav-for/as-nav-for", ["classie/classie", "flickity/js/index", "fizzy-ui-utils/utils"], function (c, d, e) {
// 			return b(a, c, d, e)
// 		}) : "object" == typeof exports ? module.exports = b(a, require("desandro-classie"), require("flickity"), require("fizzy-ui-utils")) : a.Flickity = b(a, a.classie, a.Flickity, a.fizzyUIUtils)
// 	}(window, function (a, b, c, d) {
// 		return c.createMethods.push("_createAsNavFor"), c.prototype._createAsNavFor = function () {
// 			this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), this.on("destroy", this.destroyAsNavFor);
// 			var a = this.options.asNavFor;
// 			if (a) {
// 				var b = this;
// 				setTimeout(function () {
// 					b.setNavCompanion(a)
// 				})
// 			}
// 		}, c.prototype.setNavCompanion = function (a) {
// 			a = d.getQueryElement(a);
// 			var b = c.data(a);
// 			if (b && b != this) {
// 				this.navCompanion = b;
// 				var e = this;
// 				this.onNavCompanionSelect = function () {
// 					e.navCompanionSelect()
// 				}, b.on("cellSelect", this.onNavCompanionSelect), this.on("staticClick", this.onNavStaticClick), this.navCompanionSelect()
// 			}
// 		}, c.prototype.navCompanionSelect = function () {
// 			if (this.navCompanion) {
// 				var a = this.navCompanion.selectedIndex;
// 				this.select(a), this.removeNavSelectedElement(), this.selectedIndex == a && (this.navSelectedElement = this.cells[a].element, b.add(this.navSelectedElement, "is-nav-selected"))
// 			}
// 		}, c.prototype.activateAsNavFor = function () {
// 			this.navCompanionSelect()
// 		}, c.prototype.removeNavSelectedElement = function () {
// 			this.navSelectedElement && (b.remove(this.navSelectedElement, "is-nav-selected"), delete this.navSelectedElement)
// 		}, c.prototype.onNavStaticClick = function (a, b, c, d) {
// 			"number" == typeof d && this.navCompanion.select(d)
// 		}, c.prototype.deactivateAsNavFor = function () {
// 			this.removeNavSelectedElement()
// 		}, c.prototype.destroyAsNavFor = function () {
// 			this.navCompanion && (this.navCompanion.off("cellSelect", this.onNavCompanionSelect), this.off("staticClick", this.onNavStaticClick), delete this.navCompanion)
// 		}, c
// 	}),
// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define("imagesloaded/imagesloaded", ["eventEmitter/EventEmitter", "eventie/eventie"], function (c, d) {
// 			return b(a, c, d)
// 		}) : "object" == typeof module && module.exports ? module.exports = b(a, require("wolfy87-eventemitter"), require("eventie")) : a.imagesLoaded = b(a, a.EventEmitter, a.eventie)
// 	}(window, function (a, b, c) {
// 		function d(a, b) {
// 			for (var c in b) a[c] = b[c];
// 			return a
// 		}

// 		function e(a) {
// 			return "[object Array]" == l.call(a)
// 		}

// 		function f(a) {
// 			var b = [];
// 			if (e(a)) b = a;
// 			else if ("number" == typeof a.length)
// 				for (var c = 0; c < a.length; c++) b.push(a[c]);
// 			else b.push(a);
// 			return b
// 		}

// 		function g(a, b, c) {
// 			if (!(this instanceof g)) return new g(a, b, c);
// 			"string" == typeof a && (a = document.querySelectorAll(a)), this.elements = f(a), this.options = d({}, this.options), "function" == typeof b ? c = b : d(this.options, b), c && this.on("always", c), this.getImages(), j && (this.jqDeferred = new j.Deferred);
// 			var e = this;
// 			setTimeout(function () {
// 				e.check()
// 			})
// 		}

// 		function h(a) {
// 			this.img = a
// 		}

// 		function i(a, b) {
// 			this.url = a, this.element = b, this.img = new Image
// 		}
// 		var j = a.jQuery,
// 			k = a.console,
// 			l = Object.prototype.toString;
// 		g.prototype = new b, g.prototype.options = {}, g.prototype.getImages = function () {
// 			this.images = [];
// 			for (var a = 0; a < this.elements.length; a++) {
// 				var b = this.elements[a];
// 				this.addElementImages(b)
// 			}
// 		}, g.prototype.addElementImages = function (a) {
// 			"IMG" == a.nodeName && this.addImage(a), this.options.background === !0 && this.addElementBackgroundImages(a);
// 			var b = a.nodeType;
// 			if (b && m[b]) {
// 				for (var c = a.querySelectorAll("img"), d = 0; d < c.length; d++) {
// 					var e = c[d];
// 					this.addImage(e)
// 				}
// 				if ("string" == typeof this.options.background) {
// 					var f = a.querySelectorAll(this.options.background);
// 					for (d = 0; d < f.length; d++) {
// 						var g = f[d];
// 						this.addElementBackgroundImages(g)
// 					}
// 				}
// 			}
// 		};
// 		var m = {
// 			1: !0,
// 			9: !0,
// 			11: !0
// 		};
// 		g.prototype.addElementBackgroundImages = function (a) {
// 			for (var b = n(a), c = /url\(['"]*([^'"\)]+)['"]*\)/gi, d = c.exec(b.backgroundImage); null !== d;) {
// 				var e = d && d[1];
// 				e && this.addBackground(e, a), d = c.exec(b.backgroundImage)
// 			}
// 		};
// 		var n = a.getComputedStyle || function (a) {
// 			return a.currentStyle
// 		};
// 		return g.prototype.addImage = function (a) {
// 			var b = new h(a);
// 			this.images.push(b)
// 		}, g.prototype.addBackground = function (a, b) {
// 			var c = new i(a, b);
// 			this.images.push(c)
// 		}, g.prototype.check = function () {
// 			function a(a, c, d) {
// 				setTimeout(function () {
// 					b.progress(a, c, d)
// 				})
// 			}
// 			var b = this;
// 			if (this.progressedCount = 0, this.hasAnyBroken = !1, !this.images.length) return void this.complete();
// 			for (var c = 0; c < this.images.length; c++) {
// 				var d = this.images[c];
// 				d.once("progress", a), d.check()
// 			}
// 		}, g.prototype.progress = function (a, b, c) {
// 			this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !a.isLoaded, this.emit("progress", this, a, b), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, a), this.progressedCount == this.images.length && this.complete(), this.options.debug && k && k.log("progress: " + c, a, b)
// 		}, g.prototype.complete = function () {
// 			var a = this.hasAnyBroken ? "fail" : "done";
// 			if (this.isComplete = !0, this.emit(a, this), this.emit("always", this), this.jqDeferred) {
// 				var b = this.hasAnyBroken ? "reject" : "resolve";
// 				this.jqDeferred[b](this)
// 			}
// 		}, h.prototype = new b, h.prototype.check = function () {
// 			var a = this.getIsImageComplete();
// 			return a ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image, c.bind(this.proxyImage, "load", this), c.bind(this.proxyImage, "error", this), c.bind(this.img, "load", this), c.bind(this.img, "error", this), void(this.proxyImage.src = this.img.src))
// 		}, h.prototype.getIsImageComplete = function () {
// 			return this.img.complete && void 0 !== this.img.naturalWidth
// 		}, h.prototype.confirm = function (a, b) {
// 			this.isLoaded = a, this.emit("progress", this, this.img, b)
// 		}, h.prototype.handleEvent = function (a) {
// 			var b = "on" + a.type;
// 			this[b] && this[b](a);
// 		}, h.prototype.onload = function () {
// 			this.confirm(!0, "onload"), this.unbindEvents()
// 		}, h.prototype.onerror = function () {
// 			this.confirm(!1, "onerror"), this.unbindEvents()
// 		}, h.prototype.unbindEvents = function () {
// 			c.unbind(this.proxyImage, "load", this), c.unbind(this.proxyImage, "error", this), c.unbind(this.img, "load", this), c.unbind(this.img, "error", this)
// 		}, i.prototype = new h, i.prototype.check = function () {
// 			c.bind(this.img, "load", this), c.bind(this.img, "error", this), this.img.src = this.url;
// 			var a = this.getIsImageComplete();
// 			a && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents())
// 		}, i.prototype.unbindEvents = function () {
// 			c.unbind(this.img, "load", this), c.unbind(this.img, "error", this)
// 		}, i.prototype.confirm = function (a, b) {
// 			this.isLoaded = a, this.emit("progress", this, this.element, b)
// 		}, g.makeJQueryPlugin = function (b) {
// 			b = b || a.jQuery, b && (j = b, j.fn.imagesLoaded = function (a, b) {
// 				var c = new g(this, a, b);
// 				return c.jqDeferred.promise(j(this))
// 			})
// 		}, g.makeJQueryPlugin(), g
// 	}),
// 	function (a, b) {
// 		"use strict";
// 		"function" == typeof define && define.amd ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function (c, d) {
// 			return b(a, c, d)
// 		}) : "object" == typeof exports ? module.exports = b(a, require("flickity"), require("imagesloaded")) : a.Flickity = b(a, a.Flickity, a.imagesLoaded)
// 	}(window, function (a, b, c) {
// 		"use strict";
// 		return b.createMethods.push("_createImagesLoaded"), b.prototype._createImagesLoaded = function () {
// 			this.on("activate", this.imagesLoaded)
// 		}, b.prototype.imagesLoaded = function () {
// 			function a(a, c) {
// 				var d = b.getParentCell(c.img);
// 				b.cellSizeChange(d && d.element), b.options.freeScroll || b.positionSliderAtSelected()
// 			}
// 			if (this.options.imagesLoaded) {
// 				var b = this;
// 				c(this.slider).on("progress", a)
// 			}
// 		}, b
// 	}),
// 	function (a, b) {
// 		"function" == typeof define && define.amd ? define(["jquery"], b) : "object" == typeof exports ? module.exports = b(require("jquery")) : a.Maplace = b(a.jQuery)
// 	}(this, function (a) {
// 		"use strict";

// 		function b(b) {
// 			this.VERSION = "0.2.7", this.loaded = !1, this.markers = [], this.circles = [], this.oMap = !1, this.view_all_key = "all", this.infowindow = null, this.maxZIndex = 0, this.ln = 0, this.oMap = !1, this.oBounds = null, this.map_div = null, this.canvas_map = null, this.controls_wrapper = null, this.current_control = null, this.current_index = null, this.Polyline = null, this.Polygon = null, this.Fusion = null, this.directionsService = null, this.directionsDisplay = null, this.o = {
// 				debug: !1,
// 				map_div: "#gmap",
// 				controls_div: "#controls",
// 				generate_controls: !0,
// 				controls_type: "dropdown",
// 				controls_cssclass: "",
// 				controls_title: "",
// 				controls_on_map: !0,
// 				controls_applycss: !0,
// 				controls_position: google.maps.ControlPosition.RIGHT_TOP,
// 				type: "marker",
// 				view_all: !0,
// 				view_all_text: "View All",
// 				pan_on_click: !0,
// 				start: 0,
// 				locations: [],
// 				shared: {},
// 				map_options: {
// 					mapTypeId: google.maps.MapTypeId.ROADMAP
// 				},
// 				stroke_options: {
// 					strokeColor: "#0000FF",
// 					strokeOpacity: .8,
// 					strokeWeight: 2,
// 					fillColor: "#0000FF",
// 					fillOpacity: .4
// 				},
// 				directions_options: {
// 					travelMode: google.maps.TravelMode.DRIVING,
// 					unitSystem: google.maps.UnitSystem.METRIC,
// 					optimizeWaypoints: !1,
// 					provideRouteAlternatives: !1,
// 					avoidHighways: !1,
// 					avoidTolls: !1
// 				},
// 				circle_options: {
// 					radius: 100,
// 					visible: !0
// 				},
// 				styles: {},
// 				fusion_options: {},
// 				directions_panel: null,
// 				draggable: !1,
// 				editable: !1,
// 				show_infowindows: !0,
// 				show_markers: !0,
// 				infowindow_type: "bubble",
// 				listeners: {},
// 				beforeViewAll: function () {},
// 				afterViewAll: function () {},
// 				beforeShow: function (a, b, c) {},
// 				afterShow: function (a, b, c) {},
// 				afterCreateMarker: function (a, b, c) {},
// 				beforeCloseInfowindow: function (a, b) {},
// 				afterCloseInfowindow: function (a, b) {},
// 				beforeOpenInfowindow: function (a, b, c) {},
// 				afterOpenInfowindow: function (a, b, c) {},
// 				afterRoute: function (a, b, c) {},
// 				onPolylineClick: function (a) {},
// 				onPolygonClick: function (a) {},
// 				circleRadiusChanged: function (a, b, c) {},
// 				circleCenterChanged: function (a, b, c) {},
// 				drag: function (a, b, c) {},
// 				dragEnd: function (a, b, c) {},
// 				dragStart: function (a, b, c) {}
// 			}, this.AddControl("dropdown", c), this.AddControl("list", d), b && "directions" === b.type && (!b.show_markers && (b.show_markers = !1), !b.show_infowindows && (b.show_infowindows = !1)), a.extend(!0, this.o, b)
// 		}
// 		var c, d;
// 		return c = {
// 			activateCurrent: function (a) {
// 				this.html_element.find("select").val(a)
// 			},
// 			getHtml: function () {
// 				var b, c, d = this,
// 					e = "";
// 				if (this.ln > 1) {
// 					for (e += '<select class="dropdown controls ' + this.o.controls_cssclass + '">', this.ShowOnMenu(this.view_all_key) && (e += '<option value="' + this.view_all_key + '">' + this.o.view_all_text + "</option>"), c = 0; c < this.ln; c += 1) this.ShowOnMenu(c) && (e += '<option value="' + (c + 1) + '">' + (this.o.locations[c].title || "#" + (c + 1)) + "</option>");
// 					e += "</select>", e = a(e).bind("change", function () {
// 						d.ViewOnMap(this.value)
// 					})
// 				}
// 				return b = this.o.controls_title, this.o.controls_title && (b = a('<div class="controls_title"></div>').css(this.o.controls_applycss ? {
// 					fontWeight: "bold",
// 					fontSize: this.o.controls_on_map ? "12px" : "inherit",
// 					padding: "3px 10px 5px 0"
// 				} : {}).append(this.o.controls_title)), this.html_element = a('<div class="wrap_controls"></div>').append(b).append(e), this.html_element
// 			}
// 		}, d = {
// 			html_a: function (b, c, d) {
// 				var e = this,
// 					f = c || b + 1,
// 					g = d || this.o.locations[b].title,
// 					h = a('<a data-load="' + f + '" id="ullist_a_' + f + '" href="#' + f + '" title="' + g + '"><span>' + (g || "#" + (b + 1)) + "</span></a>");
// 				return h.css(this.o.controls_applycss ? {
// 					color: "#666",
// 					display: "block",
// 					padding: "5px",
// 					fontSize: this.o.controls_on_map ? "12px" : "inherit",
// 					textDecoration: "none"
// 				} : {}), h.on("click", function (b) {
// 					b.preventDefault();
// 					var c = a(this).attr("data-load");
// 					e.ViewOnMap(c)
// 				}), h
// 			},
// 			activateCurrent: function (a) {
// 				this.html_element.find("li").removeClass("active"), this.html_element.find("#ullist_a_" + a).parent().addClass("active")
// 			},
// 			getHtml: function () {
// 				var b, c, e = a("<ul class='ullist controls " + this.o.controls_cssclass + "'></ul>").css(this.o.controls_applycss ? {
// 					margin: 0,
// 					padding: 0,
// 					listStyleType: "none"
// 				} : {});
// 				for (this.ShowOnMenu(this.view_all_key) && e.append(a("<li></li>").append(d.html_a.call(this, !1, this.view_all_key, this.o.view_all_text))), c = 0; c < this.ln; c++) this.ShowOnMenu(c) && e.append(a("<li></li>").append(d.html_a.call(this, c)));
// 				return b = this.o.controls_title, this.o.controls_title && (b = a('<div class="controls_title"></div>').css(this.o.controls_applycss ? {
// 					fontWeight: "bold",
// 					padding: "3px 10px 5px 0",
// 					fontSize: this.o.controls_on_map ? "12px" : "inherit"
// 				} : {}).append(this.o.controls_title)), this.html_element = a('<div class="wrap_controls"></div>').append(b).append(e), this.html_element
// 			}
// 		}, b.prototype.controls = {}, b.prototype.create_objMap = function () {
// 			var b, c = this,
// 				d = 0;
// 			for (b in this.o.styles) this.o.styles.hasOwnProperty(b) && (0 === d && (this.o.map_options.mapTypeControlOptions = {
// 				mapTypeIds: [google.maps.MapTypeId.ROADMAP]
// 			}), d++, this.o.map_options.mapTypeControlOptions.mapTypeIds.push("map_style_" + d));
// 			if (this.loaded) c.oMap.setOptions(this.o.map_options);
// 			else try {
// 				this.map_div.css({
// 					position: "relative",
// 					overflow: "hidden"
// 				}), this.canvas_map = a("<div>").addClass("canvas_map").css({
// 					width: "100%",
// 					height: "100%"
// 				}).appendTo(this.map_div), this.oMap = new google.maps.Map(this.canvas_map.get(0), this.o.map_options)
// 			} catch (e) {
// 				this.debug("create_objMap::" + this.map_div.selector, e.toString())
// 			}
// 			d = 0;
// 			for (b in this.o.styles) this.o.styles.hasOwnProperty(b) && (d++, this.oMap.mapTypes.set("map_style_" + d, new google.maps.StyledMapType(this.o.styles[b], {
// 				name: b
// 			})), this.oMap.setMapTypeId("map_style_" + d))
// 		}, b.prototype.add_markers_to_objMap = function () {
// 			var a, b, c = this.o.type || "marker";
// 			switch (c) {
// 				case "marker":
// 					for (a = 0; a < this.ln; a++) b = this.create_objPoint(a), this.create.marker.call(this, a, b);
// 					break;
// 				default:
// 					this.create[c].apply(this)
// 			}
// 		}, b.prototype.create_objPoint = function (b) {
// 			var c = a.extend({}, this.o.locations[b]),
// 				d = void 0 === c.visible ? void 0 : c.visible;
// 			return !c.type && (c.type = this.o.type), c.map = this.oMap, c.position = new google.maps.LatLng(c.lat, c.lon), c.zIndex = void 0 === c.zIndex ? 1e4 : c.zIndex + 100, c.visible = void 0 === d ? this.o.show_markers : d, this.o.maxZIndex = c.zIndex > this.maxZIndex ? c.zIndex : this.maxZIndex, c.image && (c.icon = new google.maps.MarkerImage(c.image, new google.maps.Size(c.image_w || 32, c.image_h || 32), new google.maps.Point(0, 0), new google.maps.Point((c.image_w || 32) / 2, (c.image_h || 32) / 2))), c
// 		}, b.prototype.create_objCircle = function (b) {
// 			var c, d, e;
// 			return e = a.extend({}, b), c = a.extend({}, this.o.stroke_options), d = a.extend({}, this.o.circle_options), a.extend(c, b.stroke_options || {}), a.extend(e, c), a.extend(d, b.circle_options || {}), a.extend(e, d), e.center = b.position, e.draggable = !1, e.zIndex = b.zIndex > 0 ? b.zIndex - 10 : 1, e
// 		}, b.prototype.add_markerEv = function (a, b, c) {
// 			var d = this;
// 			google.maps.event.addListener(c, "click", function (e) {
// 				d.o.beforeShow(a, b, c), d.o.show_infowindows && b.show_infowindow !== !1 && d.open_infowindow(a, c, e), d.o.pan_on_click && b.pan_on_click !== !1 && (d.oMap.panTo(b.position), b.zoom && d.oMap.setZoom(b.zoom)), d.current_control && d.o.generate_controls && d.current_control.activateCurrent && d.current_control.activateCurrent.call(d, a + 1), d.current_index = a, d.o.afterShow(a, b, c)
// 			}), b.draggable && this.add_dragEv(a, b, c)
// 		}, b.prototype.add_circleEv = function (a, b, c) {
// 			var d = this;
// 			google.maps.event.addListener(c, "click", function () {
// 				d.ViewOnMap(a + 1)
// 			}), google.maps.event.addListener(c, "center_changed", function () {
// 				d.o.circleCenterChanged(a, b, c)
// 			}), google.maps.event.addListener(c, "radius_changed", function () {
// 				d.o.circleRadiusChanged(a, b, c)
// 			}), b.draggable && this.add_dragEv(a, b, c)
// 		}, b.prototype.add_dragEv = function (a, b, c) {
// 			var d = this;
// 			google.maps.event.addListener(c, "drag", function (e) {
// 				var f, g;
// 				if (c.getPosition) f = c.getPosition();
// 				else {
// 					if (!c.getCenter) return;
// 					f = c.getCenter()
// 				}
// 				if (d.circles[a] && d.circles[a].setCenter(f), d.Polyline ? g = "Polyline" : d.Polygon && (g = "Polygon"), g) {
// 					for (var h = d[g].getPath(), i = h.getArray(), j = [], k = 0; k < i.length; ++k) j[k] = a === k ? new google.maps.LatLng(f.lat(), f.lng()) : new google.maps.LatLng(i[k].lat(), i[k].lng());
// 					d[g].setPath(new google.maps.MVCArray(j)), d.add_polyEv(g)
// 				}
// 				d.o.drag(a, b, c)
// 			}), google.maps.event.addListener(c, "dragend", function () {
// 				d.o.dragEnd(a, b, c)
// 			}), google.maps.event.addListener(c, "dragstart", function () {
// 				d.o.dragStart(a, b, c)
// 			}), google.maps.event.addListener(c, "center_changed", function () {
// 				d.markers[a] && c.getCenter && d.markers[a].setPosition(c.getCenter()), d.o.drag(a, b, c)
// 			})
// 		}, b.prototype.add_polyEv = function (a) {
// 			var b = this;
// 			google.maps.event.addListener(this[a].getPath(), "set_at", function (c, d) {
// 				var e = b[a].getPath().getAt(c),
// 					f = new google.maps.LatLng(e.lat(), e.lng());
// 				b.markers[c] && b.markers[c].setPosition(f), b.circles[c] && b.circles[c].setCenter(f), b.o["on" + a + "Changed"](c, d, b[a].getPath().getArray())
// 			})
// 		}, b.prototype.create = {
// 			marker: function (a, b, c) {
// 				var d;
// 				return "circle" !== b.type || c || (d = this.create_objCircle(b), b.visible || (d.draggable = b.draggable), c = new google.maps.Circle(d), this.add_circleEv(a, d, c), this.circles[a] = c), b.type = "marker", c = new google.maps.Marker(b), this.add_markerEv(a, b, c), this.oBounds.extend(b.position), this.markers[a] = c, this.o.afterCreateMarker(a, b, c), c
// 			},
// 			circle: function () {
// 				var a, b, c, d;
// 				for (a = 0; a < this.ln; a++) b = this.create_objPoint(a), "circle" === b.type && (c = this.create_objCircle(b), b.visible || (c.draggable = b.draggable), d = new google.maps.Circle(c), this.add_circleEv(a, c, d), this.circles[a] = d), b.type = "marker", this.create.marker.call(this, a, b, d)
// 			},
// 			polyline: function () {
// 				var b, c, d = a.extend({}, this.o.stroke_options);
// 				for (d.path = [], d.draggable = this.o.draggable, d.editable = this.o.editable, d.map = this.oMap, d.zIndex = this.o.maxZIndex + 100, b = 0; b < this.ln; b++) c = this.create_objPoint(b), this.create.marker.call(this, b, c), d.path.push(c.position);
// 				this.Polyline ? this.Polyline.setOptions(d) : this.Polyline = new google.maps.Polyline(d), this.add_polyEv("Polyline")
// 			},
// 			polygon: function () {
// 				var b, c, d = this,
// 					e = a.extend({}, this.o.stroke_options);
// 				for (e.path = [], e.draggable = this.o.draggable, e.editable = this.o.editable, e.map = this.oMap, e.zIndex = this.o.maxZIndex + 100, b = 0; b < this.ln; b++) c = this.create_objPoint(b), this.create.marker.call(this, b, c), e.path.push(c.position);
// 				this.Polygon ? this.Polygon.setOptions(e) : this.Polygon = new google.maps.Polygon(e), google.maps.event.addListener(this.Polygon, "click", function (a) {
// 					d.o.onPolygonClick(a)
// 				}), this.add_polyEv("Polygon")
// 			},
// 			fusion: function () {
// 				this.o.fusion_options.styles = [this.o.stroke_options], this.o.fusion_options.map = this.oMap, this.Fusion ? this.Fusion.setOptions(this.o.fusion_options) : this.Fusion = new google.maps.FusionTablesLayer(this.o.fusion_options)
// 			},
// 			directions: function () {
// 				var b, c, d, e, f, g = this,
// 					h = [],
// 					i = 0;
// 				for (b = 0; b < this.ln; b++) c = this.create_objPoint(b), 0 === b ? e = c.position : b === this.ln - 1 ? f = c.position : (d = this.o.locations[b].stopover === !0, h.push({
// 					location: c.position,
// 					stopover: d
// 				})), this.create.marker.call(this, b, c);
// 				this.o.directions_options.origin = e, this.o.directions_options.destination = f, this.o.directions_options.waypoints = h, this.directionsService || (this.directionsService = new google.maps.DirectionsService), this.directionsDisplay ? this.directionsDisplay.setOptions({
// 					draggable: this.o.draggable
// 				}) : this.directionsDisplay = new google.maps.DirectionsRenderer({
// 					draggable: this.o.draggable
// 				}), this.directionsDisplay.setMap(this.oMap), this.o.directions_panel && (this.o.directions_panel = a(this.o.directions_panel), this.directionsDisplay.setPanel(this.o.directions_panel.get(0))), this.o.draggable && google.maps.event.addListener(this.directionsDisplay, "directions_changed", function () {
// 					i = g.compute_distance(g.directionsDisplay.directions), g.o.afterRoute(i)
// 				}), this.directionsService.route(this.o.directions_options, function (a, b) {
// 					b === google.maps.DirectionsStatus.OK && (i = g.compute_distance(a), g.directionsDisplay.setDirections(a)), g.o.afterRoute(i, b, a)
// 				})
// 			}
// 		}, b.prototype.compute_distance = function (a) {
// 			var b, c = 0,
// 				d = a.routes[0],
// 				e = d.legs.length;
// 			for (b = 0; e > b; b++) c += d.legs[b].distance.value;
// 			return c
// 		}, b.prototype.type_to_open = {
// 			bubble: function (a) {
// 				this.infowindow = new google.maps.InfoWindow({
// 					content: a.html || ""
// 				})
// 			}
// 		}, b.prototype.open_infowindow = function (a, b, c) {
// 			this.CloseInfoWindow();
// 			var d = this.o.locations[a],
// 				e = this.o.infowindow_type;
// 			d.html && this.type_to_open[e] && (this.o.beforeOpenInfowindow(a, d, b), this.type_to_open[e].call(this, d), this.infowindow.open(this.oMap, b), this.o.afterOpenInfowindow(a, d, b))
// 		}, b.prototype.get_html_controls = function () {
// 			return this.controls[this.o.controls_type] && this.controls[this.o.controls_type].getHtml ? (this.current_control = this.controls[this.o.controls_type], this.current_control.getHtml.apply(this)) : ""
// 		}, b.prototype.generate_controls = function () {
// 			if (!this.o.controls_on_map) return this.controls_wrapper.empty(), void this.controls_wrapper.append(this.get_html_controls());
// 			var b = a('<div class="on_gmap ' + this.o.controls_type + ' gmap_controls"></div>').css(this.o.controls_applycss ? {
// 					margin: "5px"
// 				} : {}),
// 				c = a(this.get_html_controls()).css(this.o.controls_applycss ? {
// 					background: "#fff",
// 					padding: "5px",
// 					border: "1px solid #eee",
// 					boxShadow: "rgba(0, 0, 0, 0.298039) 0px 1px 4px -1px",
// 					maxHeight: this.map_div.find(".canvas_map").outerHeight() - 80,
// 					minWidth: 100,
// 					overflowY: "auto",
// 					overflowX: "hidden"
// 				} : {});
// 			b.append(c), this.oMap.controls[this.o.controls_position].push(b.get(0))
// 		}, b.prototype.init_map = function () {
// 			var a = this;
// 			this.Polyline && this.Polyline.setMap(null), this.Polygon && this.Polygon.setMap(null), this.Fusion && this.Fusion.setMap(null), this.directionsDisplay && this.directionsDisplay.setMap(null);
// 			for (var b = this.markers.length - 1; b >= 0; b -= 1) try {
// 				this.markers[b] && this.markers[b].setMap(null)
// 			} catch (c) {
// 				a.debug("init_map::markers::setMap", c.stack)
// 			}
// 			this.markers.length = 0, this.markers = [];
// 			for (var d = this.circles.length - 1; d >= 0; d -= 1) try {
// 				this.circles[d] && this.circles[d].setMap(null)
// 			} catch (c) {
// 				a.debug("init_map::circles::setMap", c.stack)
// 			}
// 			this.circles.length = 0, this.circles = [], this.o.controls_on_map && this.oMap.controls && this.oMap.controls[this.o.controls_position].forEach(function (b, c) {
// 				try {
// 					a.oMap.controls[this.o.controls_position].removeAt(c)
// 				} catch (d) {
// 					a.debug("init_map::removeAt", d.stack)
// 				}
// 			}), this.oBounds = new google.maps.LatLngBounds
// 		}, b.prototype.perform_load = function () {
// 			1 === this.ln ? (this.o.map_options.set_center ? this.oMap.setCenter(new google.maps.LatLng(this.o.map_options.set_center[0], this.o.map_options.set_center[1])) : (this.oMap.fitBounds(this.oBounds), this.ViewOnMap(1)), this.o.map_options.zoom && this.oMap.setZoom(this.o.map_options.zoom)) : 0 === this.ln ? (this.o.map_options.set_center ? this.oMap.setCenter(new google.maps.LatLng(this.o.map_options.set_center[0], this.o.map_options.set_center[1])) : this.oMap.fitBounds(this.oBounds), this.oMap.setZoom(this.o.map_options.zoom || 1)) : (this.oMap.fitBounds(this.oBounds), "number" == typeof (this.o.start - 0) && this.o.start > 0 && this.o.start <= this.ln ? this.ViewOnMap(this.o.start) : this.o.map_options.set_center ? this.oMap.setCenter(new google.maps.LatLng(this.o.map_options.set_center[0], this.o.map_options.set_center[1])) : this.ViewOnMap(this.view_all_key), this.o.map_options.zoom && this.oMap.setZoom(this.o.map_options.zoom))
// 		}, b.prototype.debug = function (a, b) {
// 			return this.o.debug && console.log(a, b), this
// 		}, b.prototype.AddControl = function (a, b) {
// 			return a && b ? (this.controls[a] = b, this) : (self.debug("AddControl", 'Missing "name" and "func" callback.'), !1)
// 		}, b.prototype.CloseInfoWindow = function () {
// 			return this.infowindow && (this.current_index || 0 === this.current_index) && (this.o.beforeCloseInfowindow(this.current_index, this.o.locations[this.current_index]), this.infowindow.close(), this.infowindow = null, this.o.afterCloseInfowindow(this.current_index, this.o.locations[this.current_index])), this
// 		}, b.prototype.ShowOnMenu = function (a) {
// 			if (a === this.view_all_key && this.o.view_all && this.ln > 1) return !0;
// 			if (a = parseInt(a, 10), "number" == typeof (a - 0) && a >= 0 && a < this.ln) {
// 				var b = this.o.locations[a].on_menu !== !1;
// 				if (b) return !0
// 			}
// 			return !1
// 		}, b.prototype.ViewOnMap = function (a) {
// 			if (a === this.view_all_key) this.o.beforeViewAll(), this.current_index = a, this.o.locations.length > 0 && this.o.generate_controls && this.current_control && this.current_control.activateCurrent && this.current_control.activateCurrent.apply(this, [a]), this.oMap.fitBounds(this.oBounds), this.CloseInfoWindow(), this.o.afterViewAll();
// 			else if (a = parseInt(a, 10), "number" == typeof (a - 0) && a > 0 && a <= this.ln) try {
// 				google.maps.event.trigger(this.markers[a - 1], "click")
// 			} catch (b) {
// 				this.debug("ViewOnMap::trigger", b.stack)
// 			}
// 			return this
// 		}, b.prototype.SetLocations = function (a, b) {
// 			return this.o.locations = a, b && this.Load(), this
// 		}, b.prototype.AddLocations = function (b, c) {
// 			var d = this;
// 			return a.isArray(b) && a.each(b, function (a, b) {
// 				d.o.locations.push(b)
// 			}), a.isPlainObject(b) && this.o.locations.push(b), c && this.Load(), this
// 		}, b.prototype.AddLocation = function (b, c, d) {
// 			return a.isPlainObject(b) && this.o.locations.splice(c, 0, b), d && this.Load(), this
// 		}, b.prototype.RemoveLocations = function (b, c) {
// 			var d = this,
// 				e = 0;
// 			return a.isArray(b) ? a.each(b, function (a, b) {
// 				b - e < d.ln && d.o.locations.splice(b - e, 1), e++
// 			}) : b < this.ln && this.o.locations.splice(b, 1), c && this.Load(), this
// 		}, b.prototype.Loaded = function () {
// 			return this.loaded
// 		}, b.prototype._init = function () {
// 			this.ln = this.o.locations.length;
// 			for (var b = 0; b < this.ln; b++) {
// 				var c = a.extend({}, this.o.shared);
// 				this.o.locations[b] = a.extend(c, this.o.locations[b]), this.o.locations[b].html && (this.o.locations[b].html = this.o.locations[b].html.replace("%index", b + 1), this.o.locations[b].html = this.o.locations[b].html.replace("%title", this.o.locations[b].title || ""))
// 			}
// 			return this.map_div = a(this.o.map_div), this.controls_wrapper = a(this.o.controls_div), this
// 		}, b.prototype.Load = function (b) {
// 			a.extend(!0, this.o, b), b && b.locations && (this.o.locations = b.locations), this._init(), this.o.visualRefresh === !1 ? google.maps.visualRefresh = !1 : google.maps.visualRefresh = !0, this.init_map(), this.create_objMap(), this.add_markers_to_objMap(), this.ln > 1 && this.o.generate_controls || this.o.force_generate_controls ? (this.o.generate_controls = !0, this.generate_controls()) : this.o.generate_controls = !1;
// 			var c = this;
// 			if (this.loaded) this.perform_load();
// 			else {
// 				google.maps.event.addListenerOnce(this.oMap, "idle", function () {
// 					c.perform_load()
// 				});
// 				for (var d in this.o.listeners) this.o.listeners.hasOwnProperty(d) && google.maps.event.addListener(this.oMap, d, this.o.listeners[d])
// 			}
// 			return this.loaded = !0, this
// 		}, b
// 	});
// var IS_FLEX, IS_TOUCH, NYM, UTIL;
// UTIL = {}, NYM = {}, UTIL.CLICK = IS_TOUCH ? "touchstart" : "click", UTIL.MOUSEENTER = IS_TOUCH ? "touchstart" : "mouseenter", UTIL.MOUSELEAVE = IS_TOUCH ? "touchend" : "mouseleave", IS_TOUCH = "", /touch|tablet|mobile|phone|android|iphone|ipad|blackberry/i.test(window.navigator.userAgent) ? (IS_TOUCH = !0, document.documentElement.className = "is-touch") : (IS_TOUCH = !1, document.documentElement.className = "is-no-touch"), IS_FLEX = "", Modernizr.flexbox && Modernizr.flexwrap ? (IS_TOUCH = !0, document.documentElement.className = "is-flex-wrap") : (IS_TOUCH = !1, document.documentElement.className = "is-no-flex-wrap"), UTIL.SCROLLER = function (a, b, c) {
// 	return $("html,body").animate({
// 		scrollTop: a
// 	}, b, c), !1
// }, UTIL.SCROLL_CANCEL = function () {
// 	return $("body,html").on("mousewheel touchstart", function () {
// 		return $("body,html").stop()
// 	})
// }, UTIL.PAGE_TOP = function () {
// 	return $(document).on(UTIL.CLICK, ".js-pagetop", function () {
// 		return UTIL.SCROLLER(40, 0, "linear"), UTIL.SCROLLER(0, 600, "easeOutExpo")
// 	})
// }, UTIL.HOVER = function () {
// 	return $(document).on(UTIL.MOUSEENTER, "a,button,.hov", function () {
// 		var a;
// 		return a = $(this), a.addClass("hover")
// 	}), $(document).on(UTIL.MOUSELEAVE, "a,button,.hov", function () {
// 		var a;
// 		return a = $(this), a.removeClass("hover")
// 	})
// }, NYM.STICKY_HEADER = function () {
// 	var a, b;
// 	return b = $("#gnav-dummy").offset().top, $(window).on("load debouncedresize", function () {
// 		return b = $("#gnav-dummy").offset().top
// 	}), a = function () {
// 		var a;
// 		return a = $(window).scrollTop(), a >= b ? $("#gnav-real").addClass("is-sticky") : $("#gnav-real").removeClass("is-sticky")
// 	}, a(), $(window).on("load scroll", function () {
// 		return a()
// 	})
// }, NYM.NEST_NAV = function () {
// 	return $("#gnav-menu").find(".menu").each(function (a) {
// 		var b, c, d;
// 		return d = $(this), b = d.find(".nest-button.is-active"), c = d.find(".nest-trigger"), d.on("mouseenter", function () {
// 			return $(window).width() > 768 ? (d.find(".gnav-nest").addClass("is-visible"), d.find(".menu-button").addClass("is-nest-visible")) : void 0
// 		}), d.on("mouseleave", function () {
// 			return $(window).width() > 768 ? (d.find(".gnav-nest").removeClass("is-visible"), d.find(".menu-button").removeClass("is-nest-visible")) : void 0
// 		}), b.on("mouseenter", function () {
// 			var a;
// 			return !$(this).hasClass("is-disable") && $(window).width() > 768 ? (a = b.index(this), d.find(".nest-post").removeClass("is-show"), d.find(".nest-post").eq(a).addClass("is-show")) : void 0
// 		}), c.on(UTIL.CLICK, function () {
// 			return $(this).toggleClass("is-current"), d.find(".gnav-nest").toggleClass("is-visible"), d.find(".menu-button").toggleClass("is-nest-visible"), !1
// 		})
// 	})
// }, NYM.HEADER_SPNAV = function () {
// 	return $(document).on(UTIL.CLICK, "#header-sp-trigger", function () {
// 		return $(this).hasClass("is-sp-nav-active") ? ($(this).removeClass("is-sp-nav-active"), $("#gnav").removeClass("is-show-sp"), $("#header-sp-overlay").removeClass("is-sp-nav-active"), $("body").removeClass("is-sp-nav-active")) : ($(this).addClass("is-sp-nav-active"), $("#gnav").addClass("is-show-sp"), $("#header-sp-overlay").addClass("is-sp-nav-active"), $("body").addClass("is-sp-nav-active")), !1
// 	}), $(document).on(UTIL.CLICK, "#header-sp-overlay", function () {
// 		return $(this).removeClass("is-sp-nav-active"), $("#gnav").removeClass("is-show-sp"), $("#header-sp-trigger").removeClass("is-sp-nav-active"), $("body").removeClass("is-sp-nav-active"), !1
// 	})
// }, NYM.SINGLE_LOCAL_NAV = function () {
// 	var a;
// 	return !IS_TOUCH && $(".local-nav")[0] ? (a = $(".local-nav-dummy").offset().top - $("#gnav-real").height(), $(window).on("load debouncedresize", function () {
// 		return a = $(".local-nav-dummy").offset().top - $("#gnav-real").height()
// 	}), $(window).on("load scroll", function () {
// 		var b;
// 		return b = $(window).scrollTop(), b >= a ? $(".local-nav").addClass("is-sticky") : $(".local-nav").removeClass("is-sticky")
// 	})) : void 0
// }, NYM.SINGLE_LOCAL_NAV_CURRENT = function () {
// 	var a, b, c, d, e;
// 	if ($(".local-nav")[0]) {
// 		if ($(".local-nav").hasClass("is-no-inbound-scroll")) return;
// 		return e = "", a = $(".local-nav").find("a"), b = function () {
// 			var b, c, d, f, g;
// 			for (e = new Array, b = 0, c = []; b <= a.length - 1;) d = $(".module-inboundscroll-wrapper").eq(b), g = d.offset().top - 1, f = g + d.outerHeight(!0), e[b] = [g, f], c.push(b++);
// 			return c
// 		}, b(), $(window).on("load debouncedresize", function () {
// 			return b()
// 		}), d = function () {
// 			var b, c, d;
// 			for (b = $(window).scrollTop(), d = 0, c = !1; d <= e.length - 1;) e[d][0] <= b && e[d][1] >= b && (c = !0, a.removeClass("is-current"), a.eq(d).addClass("is-current"), d === e.length), d++;
// 			return c ? void 0 : a.removeClass("is-current")
// 		}, $(window).on("load scroll debouncedresize", function () {
// 			return d()
// 		}), (c = function () {
// 			return $(document.body).on("click", ".local-nav a", function () {
// 				var a, b, c, d;
// 				return a = $(this), b = $(".local-nav a").index(this), c = $(".module-inboundscroll-wrapper").eq(b), d = c.offset().top - 100, UTIL.SCROLLER(d, 1200, "easeInOutExpo")
// 			})
// 		})()
// 	}
// }, NYM.SINGLE_PAGENAV_STICKY = function () {
// 	var a, b, c, d, e;
// 	return $(".pagenav")[0] ? (b = "", d = "", c = $(".pagenav"), a = $(".pagenav-bottom-flag"), e = function () {
// 		return b = a.offset().top, d = $(window).height() / 2 + c.height() / 2
// 	}, e(), $(".section-digest-single").imagesLoaded(function () {
// 		return e()
// 	}), $(window).on("load debouncedresize", function () {
// 		return e()
// 	}), $(window).on("load scroll debouncedresize", function () {
// 		var a;
// 		return a = $(window).scrollTop() + d, a >= b ? $(".pagenav").addClass("is-sticky") : $(".pagenav").removeClass("is-sticky")
// 	})) : void 0
// }, NYM.ARTICLE_CAROUSEL = function () {
// 	var a;
// 	return a = $(".article-carousel"), a.each(function () {
// 		var a, b;
// 		return b = $(this), a = b.flickity({
// 			cellSelector: ".article",
// 			cellAlign: "left",
// 			wrapAround: !0,
// 			prevNextButtons: !0,
// 			pageDots: !1,
// 			autoPlay: 3e3,
// 			arrowShape: {
// 				x0: 30,
// 				x1: 60,
// 				y1: 30,
// 				x2: 65,
// 				y2: 30,
// 				x3: 35
// 			}
// 		})
// 	})
// }, NYM.MAP = function () {
// 	var a, b;
// 	return b = $(window).width() > 767 ? 15 : 14, a = $(".gmap"), a[0] ? a.each(function () {
// 		var a, c;
// 		return c = $(this), a = new Maplace({
// 			map_div: c,
// 			generate_controls: !1,
// 			show_infowindows: !1,
// 			map_options: {
// 				mapTypeControl: !1,
// 				streetViewControl: !1,
// 				zoomControl: !1,
// 				draggable: !1,
// 				scrollwheel: !1
// 			},
// 			locations: [{
// 				lat: c.data("lat"),
// 				lon: c.data("lon"),
// 				zoom: b
// 			}],
// 			styles: {
// 				NYM: [{
// 					featureType: "administrative",
// 					elementType: "all",
// 					stylers: [{
// 						visibility: "on"
// 					}, {
// 						color: "#0e2537"
// 					}]
// 				}, {
// 					featureType: "administrative",
// 					elementType: "labels.text.stroke",
// 					stylers: [{
// 						visibility: "off"
// 					}, {
// 						color: "#0e2537"
// 					}]
// 				}, {
// 					featureType: "road",
// 					elementType: "all",
// 					stylers: [{
// 						visibility: "on"
// 					}, {
// 						hue: "#0e2537"
// 					}]
// 				}, {
// 					featureType: "water",
// 					elementType: "all",
// 					stylers: [{
// 						visibility: "on"
// 					}, {
// 						color: "#41acff"
// 					}]
// 				}, {
// 					featureType: "poi",
// 					elementType: "all",
// 					stylers: [{
// 						visibility: "off"
// 					}]
// 				}, {
// 					featureType: "transit",
// 					elementType: "all",
// 					stylers: [{
// 						visibility: "off"
// 					}]
// 				}]
// 			}
// 		}).Load()
// 	}) : void 0
// }, NYM.ARCHIVE_ANCHOR_SCROLL = function () {
// 	return $(".module-archive-single-content").find("a[href^=#]").on(UTIL.CLICK, function () {
// 		var a, b, c;
// 		return a = $(this).attr("href"), c = $("#" === a || "" === a ? "html" : a), b = c.offset().top - 80, UTIL.SCROLLER(b, 1200, "easeInOutExpo"), !1
// 	})
// }, $(function () {
// 	return UTIL.PAGE_TOP(), UTIL.SCROLL_CANCEL(), UTIL.HOVER(), NYM.STICKY_HEADER(), NYM.NEST_NAV(), NYM.HEADER_SPNAV(), NYM.SINGLE_LOCAL_NAV(), NYM.SINGLE_LOCAL_NAV_CURRENT(), NYM.SINGLE_PAGENAV_STICKY(), NYM.ARTICLE_CAROUSEL(),  NYM.MAP(), NYM.ARCHIVE_ANCHOR_SCROLL()
// });
